window.addEventListener('DOMContentLoaded', () => {
    'use strict'

    const mediaMinQueryForm = window.matchMedia('(min-width: 992px)');
    const mediaMaxQueryForm = window.matchMedia('(max-width: 991px)');
    const mediaMaxChapterFixed = window.matchMedia('(min-width: 1200px)');
    const mediaMinChapterFixed = window.matchMedia('(max-width: 1200px)');

    const overlow = document.querySelector('.overlow');
    const body = document.querySelector('body');

    let scrollWidth = window.innerWidth;
    const windowWidth = window.innerWidth;

    if ('scrollWidth' in document.body) {
        scrollWidth = document.body.scrollWidth; // width scroll
    }

    const totalScrollWidth = windowWidth - scrollWidth;
    let scrollDocument = '';

    function overlowShow() {
        if (mediaMaxChapterFixed.matches) {
            body.style.paddingRight = `${totalScrollWidth}px`;
            if (scrollDocument !== '') scrollDocument.style.paddingRight = `${totalScrollWidth}px`;
        }
        body.style.overflow = 'hidden';
        overlow.classList.add('overlow--active');
    }

    function overlowHide() {
        overlow.classList.remove('overlow--active');
        body.style.paddingRight = '';
        body.style.overflow = '';
        if (scrollDocument !== '') scrollDocument.style.paddingRight = '';
    }

    // const overlow = document.querySelector('.overlow');
    // const body = document.querySelector('body');
    //
    // function overlowShow() {
    //     if (mediaMaxChapterFixed.matches) {
    //         body.style.paddingRight = '17px';
    //     }
    //     body.style.overflow = 'hidden';
    //     overlow.classList.add('overlow--active');
    // }
    //
    // function overlowHide() {
    //     overlow.classList.remove('overlow--active');
    //     body.style.paddingRight = '';
    //     body.style.overflow = '';
    // }






    // ..:: Begin Ленивая загрузка ::..
    function lazyLoading() {
        const lazyMedia = document.querySelectorAll(".lazy-images");
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const media = entry.target;

                    if (media.tagName === "VIDEO") {
                        // Подставляем постер лениво
                        if (media.dataset && media.dataset.poster) {
                            media.setAttribute('poster', media.dataset.poster);
                        }
                        const source = media.querySelector("source");
                        if (source && source.dataset.src) {
                            source.src = source.dataset.src;
                            media.load();
                        }
                    } else if (media.tagName === "IMG" || media.querySelector("img")) {
                        // Подставляем srcset для source в picture, если есть
                        const sources = media.querySelectorAll("source");
                        sources.forEach((sourceEl) => {
                            if (sourceEl.dataset && sourceEl.dataset.srcset) {
                                sourceEl.srcset = sourceEl.dataset.srcset;
                            }
                            if (sourceEl.dataset && sourceEl.dataset.src) {
                                sourceEl.src = sourceEl.dataset.src;
                            }
                        });

                        // Устанавливаем src для изображения
                        const img = media.tagName === "IMG" ? media : media.querySelector("img");
                        if (img && img.dataset && img.dataset.src) {
                            img.src = img.dataset.src;

                            const skeletonContainer = img.closest('.lazy-images');
                            if (skeletonContainer && skeletonContainer.querySelector('.skeleton-img')) {
                                skeletonContainer.querySelector('.skeleton-img').remove();
                            }
                        }
                    }
                    observer.unobserve(media);
                }
            });
        });

        lazyMedia.forEach((media) => {
            observer.observe(media);
        });
    }
    // Немедленно подставляем постеры, чтобы не было чёрного фона до срабатывания Observer
    (function initVideoPostersImmediately() {
        const videosWithPoster = document.querySelectorAll('video.lazy-images');
        videosWithPoster.forEach((videoEl) => {
            if (videoEl.dataset && videoEl.dataset.poster && !videoEl.getAttribute('poster')) {
                videoEl.setAttribute('poster', videoEl.dataset.poster);
            }
        });
    })();

    lazyLoading();
    // ..:: End Ленивая загрузка ::..










    // begin Fixed menu header
    // const fixedIntroMenu = document.querySelector('.js-header__intro-fixed');
    const fixedIntroMenu = document.querySelector('.header__intro-wrap');
    const header = document.querySelector('.header');

    if (fixedIntroMenu) {
        document.addEventListener('scroll', () => {
            let scrollY = window.pageYOffset;
            if (scrollY > 800) {
                fixedIntroMenu.classList.add('fixed--menu');
                fixedIntroMenu.classList.add('active');
                header.style.paddingTop = `${100}px`;
                scrollDocument = document.querySelector('.header__intro-wrap');
            } else {
                fixedIntroMenu.classList.remove('fixed--menu');
                fixedIntroMenu.classList.remove('active');
                header.style.paddingTop = '';
                scrollDocument = ''
            }
        });
    }

    // Страница product
    const productInfoFixed = document.querySelector('.info__fixed');
    if (productInfoFixed) {
        document.addEventListener('scroll', () => {
            let scrollY = window.pageYOffset;
            if (scrollY > 450) {
                productInfoFixed.classList.add('active');
                scrollDocument = productInfoFixed;
            } else {
                productInfoFixed.classList.remove('active');
                scrollDocument = '';
            }
        });
    }
    // Страница product

    // Лейдинг
    const fixedMenuLeiding = document.querySelector('.header__production');
    if (fixedMenuLeiding) {
        document.addEventListener('scroll', () => {
            let scrollY = window.pageYOffset;
            if (scrollY > 300) {
                fixedMenuLeiding.classList.add('header__production--fixed');
                fixedMenuLeiding.classList.add('active');
                scrollDocument = fixedMenuLeiding;
            } else {
                fixedMenuLeiding.classList.remove('header__production--fixed');
                fixedMenuLeiding.classList.remove('active');
                scrollDocument = '';
            }
        });
    }
    // Лейдинг
    // end Fixed menu header


    // begin УНИВЕРСАЛЬНЫЙ скрипт для модальных окон
    /*
        1. Модальному окну надо написать data-modal="number" (добавить класс modalWindow);
        2. Модальному окну ко второму родителю (добавить класс modalOverlow):
        3. Кнопке по которуму будет открываться модальное окно написать data-modalBtn="number" (добавить класс modalBtn);
        4. Закрытие модального окна на нажатию крестик data-close="number" (добавить класс modalClose);
    */
    function uneversalModal() {
        const modalBtn = document.querySelectorAll('.modalBtn');
        const modalWindow = document.querySelectorAll('.modalWindow');
        const modalClose = document.querySelectorAll('.modalClose');


        for (let i = 0; i < modalBtn.length; i++) {
            modalBtn[i].addEventListener('click', (e) => {
                e.preventDefault();
                const dataModalBtn = +modalBtn[i].dataset.modalbtn;
                modalWindow.forEach(element => {
                    const dataModal = +element.dataset.modal;
                    if (dataModalBtn === dataModal) {
                        element.classList.add('show');
                        overlowShow();
                        overlow.setAttribute('data-overlow', `${dataModal}`);
                    }
                });
            });
        }

        for (let i = 0; i < modalClose.length; i++) {
            modalClose[i].addEventListener('click', () => {
                const dataClose = +modalClose[i].dataset.close;
                modalWindow.forEach(element => {
                    const dataModal = +element.dataset.modal;
                    if (dataClose === dataModal) {
                        element.classList.remove('show');
                        overlowHide();
                        overlow.setAttribute('data-overlow', `${dataModal}`);
                    }
                });
            });
        }

        for (let i = 0; i < modalWindow.length; i++) {
            modalWindow[i].addEventListener('click', (e) => {
                if ((e.target !== modalWindow[i]) &&
                    (e.target !== modalWindow[i].querySelector('.modalOverlow')) &&
                    e.target !== modalWindow[i].querySelector('.reviewspage__form-wrapper')) {
                    return;
                }
                modalWindow[i].classList.remove('show');
                overlowHide();
            });
        }

        document.addEventListener('keydown', (e) => {
            modalWindow.forEach(el => {
                if (el.classList.contains('show')) {
                    if (e.keyCode === 27) el.classList.remove('show');
                }
            });
        });
    }
    uneversalModal();
    // end УНИВЕРСАЛЬНЫЙ скрипт для модальных окон









    // begin arrowtop (По нажатию на стрелку страница поднимается вверх)
    const arrowtop = document.querySelector('.arrowtop');
    window.addEventListener('scroll', () => {
        window.pageYOffset > 500 ? arrowtop.classList.add('arrowtop--active') : arrowtop.classList.remove('arrowtop--active');
    });
    if (arrowtop) {
        arrowtop.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}));
    }
    // end arrowtop (По нажатию на стрелку страница поднимается вверх)






    // begin Слайдеры на главной странице
    const sliders = document.querySelectorAll('.slider');
    if (sliders) {
        for (let i = 0; i < sliders.length; i++) {
            console.log("gggg")
            const slides = Array.from(sliders[i].querySelectorAll('.slide'));
            const slideItem = sliders[i].querySelectorAll('.slide__item');
            const sliderPagination = sliders[i].querySelector('.slider__pagination');
            const sliderTrack = sliders[i].querySelectorAll('.slider-track');
            const sliderBtnNext = sliders[i].querySelector('.slider__arrow-next');
            const sliderBtnPrev = sliders[i].querySelector('.slider__arrow-prev');

            let trackWidth = 0;

            slides.forEach(element => {
                trackWidth = element.getBoundingClientRect().width;
            });

            //begin Создания Пагинации
            slideItem.forEach(el => {
                const span = document.createElement('span');
                span.classList.add('slider__pagination-dots');
                sliderPagination.appendChild(span);
            });

            const paginationsSpan = sliderPagination.querySelectorAll('.slider__pagination-dots');
            paginationsSpan[0].classList.add('slider__pagination-dots--active');
            //end Создания Пагинации

            slideActive(sliderBtnPrev, sliderBtnNext, trackWidth, sliderTrack, slideItem, paginationsSpan);
        }

        function removeActive(dots, slide) {
            dots.forEach(element => {
                element.classList.remove('slider__pagination-dots--active')
            });

            slide.forEach(element => {
                element.classList.remove('slide--active');
            });
        }

        function addActive(dots, slide, countSlide) {
            dots[countSlide].classList.add('slider__pagination-dots--active');
            slide[countSlide].classList.add('slide--active');
        }

        function slideActive(btnPrev, btnNext, sliderWidth, sliderTrack, slide, dots) {
            let countSlide = 0;

            btnPrev.addEventListener('click', btnPrevActive);
            btnNext.addEventListener('click', btnNextActive);

            function btnNextActive() {
                countSlide++;
                removeActive(dots, slide);
                if (countSlide >= slide.length) {
                    countSlide = 0;
                    sliderTrack.forEach(element => {
                        element.style.transition = '';
                    });
                } else {
                    sliderTrack.forEach(element => {
                        element.style.transition = 'transform .5s linear';
                    });
                }
                addActive(dots, slide, countSlide);
                sliderTarck(sliderTrack, sliderWidth, countSlide);
            }

            function btnPrevActive() {
                countSlide--;
                removeActive(dots, slide);
                if (countSlide < 0) {
                    countSlide = slide.length - 1;
                    sliderTrack.forEach(element => {
                        element.style.transition = '';
                    });
                } else {
                    sliderTrack.forEach(element => {
                        element.style.transition = 'transform .5s linear';
                    });
                }
                addActive(dots, slide, countSlide);
                sliderTarck(sliderTrack, sliderWidth, countSlide);
            }

            dots.forEach((el, i) => {
                el.addEventListener('click', () => {
                    removeActive(dots, slide);
                    countSlide = i;
                    el.classList.add('slider__pagination-dots--active');
                    sliderTarck(sliderTrack, sliderWidth, countSlide);
                    addActive(dots, slide, countSlide);
                })
            });

            // Swap
            sliderTrack.forEach(el => {

                let startPos = 0;
                let currentTranslate = 0;
                let prevTranslate = 0;
                let animationID;

                slide.forEach((slide, index) => {
                    const slideImage = slide.querySelector('img');
                    if (slideImage) {
                        slideImage.addEventListener('dragstart', (e) => e.preventDefault());
                    }

                    slide.addEventListener('touchstart', touchStart(index));
                    slide.addEventListener('touchend', touchEnd);
                    slide.addEventListener('touchmove', touchMove);
                });

                function getPositionX(event) {
                    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
                }

                function touchStart(index) {
                    return function (event) {
                        countSlide = index;
                        startPos = getPositionX(event);
                        animationID = requestAnimationFrame(animation);
                    }
                }

                function touchMove(event) {
                    const currentPosition = getPositionX(event);
                    currentTranslate = prevTranslate + currentPosition - startPos;
                }

                function touchEnd() {
                    cancelAnimationFrame(animationID);
                    const movedBy = currentTranslate - prevTranslate;
                    if (movedBy < -150 && countSlide < slide.length - 1) {
                        dots[countSlide].classList.remove('slider__pagination-dots--active');
                        countSlide++;
                        dots[countSlide].classList.add('slider__pagination-dots--active');
                    }
                    if (movedBy > 150 && countSlide > 0) {
                        dots[countSlide].classList.remove('slider__pagination-dots--active');
                        countSlide--;
                        dots[countSlide].classList.add('slider__pagination-dots--active');
                    }

                    setPositionByIndex();
                }

                function setPositionByIndex() {
                    slide.forEach(element => {
                        currentTranslate = countSlide * -element.getBoundingClientRect().width;
                    });
                    prevTranslate = currentTranslate;
                    setSliderPosition();
                }

                function animation() {
                    setSliderPosition();
                    requestAnimationFrame(animation);
                }

                function setSliderPosition() {
                    el.style.transform = `translate3d(${currentTranslate}px, 0px, 0px)`;
                }
            });
            // Swap

            //begin Отключения контекстное меню
            sliderTrack.forEach(element => {
                element.oncontextmenu = function (e) {
                    e.preventDefault();
                };
            });
            //end Отключения контекстное меню

            //begin Тайм слайдера 3сек
            if (mediaMinQueryForm.matches) {
                let timeSlider1;
                function timeSlider() {
                    clearInterval(timeSlider1);
                    timeSlider1 = setInterval(() => {
                        btnNextActive();
                    }, 8000);
                }

                const slidersMain = document.querySelectorAll('.slider');
                slidersMain.forEach(el => {
                    el.addEventListener('mouseover', () => {
                        clearInterval(timeSlider1);
                    });
                });

                slidersMain.forEach(el => {
                    el.addEventListener('mouseout', () => {
                        timeSlider();
                    });
                });
                timeSlider();
            }
            //end Тайм слайдера 3сек
        }

        function sliderTarck(sliderTrack, sliderWidth, countSlide) {
            sliderTrack.forEach(element => {
                element.style.transform = `translate3d(-${sliderWidth * countSlide}px, 0px, 0px)`;
            });
        }
    }
    // end Слайдеры на главной странице














    // begin animation product
    // пагинации картинок
    const productCards = document.querySelectorAll('.product__card');
    if(productCards) {
        productCards.forEach(el => {
            let currentProduct = el;
            const imageSwitchItems = currentProduct.querySelectorAll('.product__images-item');
            const imageSwitchPagination = currentProduct.querySelector('.product__images-pagination');
            if (imageSwitchItems.length > 1) {
                imageSwitchItems.forEach((el, index) => {
                    el.setAttribute('data-index', index);
                    imageSwitchPagination.innerHTML += `<span class="product__images-pagination-item ${index == 0 ? 'product__images-pagination-item--active' : ''}" data-index="${index}"></span>`;
                    el.addEventListener('mouseenter', (e) => {
                        currentProduct.querySelectorAll('.product__images-pagination-item').forEach(el => {el.classList.remove('product__images-pagination-item--active')});
                        currentProduct.querySelector(`.product__images-pagination-item[data-index="${e.currentTarget.dataset.index}"]`).classList.add('product__images-pagination-item--active')
                    });
                    el.addEventListener('mouseleave', (e) => {
                        currentProduct.querySelectorAll('.product__images-pagination-item').forEach(el => {el.classList.remove('product__images-pagination-item--active')});
                        currentProduct.querySelector(`.product__images-pagination-item[data-index="0"]`).classList.add('product__images-pagination-item--active')
                    });
                });
            }
        });
    }
    // пагинации картинок
    // ...... Добавляет before (ОБводка продукта белым фоном "карточки")
    productCards.forEach(element => {
        const productCard = element.getBoundingClientRect();
        element.addEventListener('mouseenter', () => {
            const cardHeight = element.getBoundingClientRect().height;
            element.style.minHeight = cardHeight + 'px';
            element.classList.add('product--hover');
        });

        element.addEventListener('mouseleave', () => {
            element.style.minHeight = '';
            element.classList.remove('product--hover');
        });
    });
    // ...... Добавляет before (ОБводка продукта белым фоном "карточки")
    // end animation product













    // begin print text input placeholder (печатает текст в поиске)
    const headerIntroFormInputText = document.querySelector('.header__intro-form-input--text');
    const headerIntroFormInput = document.querySelector('.header__intro-form-input');
    let intervalSearchPrintText;
    /*setTimeout(() => {
        if (headerIntroFormInputText) {
            const delay = 165;
            let countText = 0;
            let lineText = 0;
            let addText = '';
            const nameHeader = [
                'Заборы ЖБИ\n',
                'Плиты перекрытия\n',
                'Лестничные марши\n',
                'Люки канализионные\n',
                'Дорожные плиты\n',
                'Опоры ЛЭП\n',
                'Чугунные изделия\n',
            ];
            function printText() {
                intervalSearchPrintText = setTimeout(() => {
                    addText += nameHeader[lineText][countText];
                    headerIntroFormInputText.placeholder = addText + '|';
                    countText++;
                    if (countText >= nameHeader[lineText].length) {
                        countText++;
                        countText = 0;
                        addText = nameHeader[countText];
                        addText = '';
                        lineText++;
                        if (lineText == nameHeader.length) {
                            clearTimeout(intervalSearchPrintText);
                            headerIntroFormInputText.placeholder = 'Поиск по товарам, категориям и ГОСТ';
                            return
                        }
                    }
                    printText();
                }, delay);
            }
            printText();
        }
    }, 1500);*/
    // end print text input placeholder ((печатает текст в поиске)












    // begin search form
    const headerFormArrowBack = document.querySelector('.header__intro-top--arrow');
    const headerFormArrowCloseResult = document.querySelector('.header__intro-top--arrow--closeResult');
    const headerFormSearchClose = document.querySelector('.header__intro-form-icon--close');
    const overlowFormBackground = document.querySelector('.form--background');
    const headerFormIconAdvancedsearchs = document.querySelector('.header__intro-form-icon--advancedsearchs');

    const categoriesSearchBtnIcon = document.querySelector('.content-categories__btnsearch');

    if (mediaMinQueryForm.matches) {
        if (headerIntroFormInput) {
            headerIntroFormInput.addEventListener('input', (e) => {
                const headerIntroTopForm = e.target.closest('.header__intro-top');
                if (headerIntroFormInput.value !== '') {
                    if (headerFormIconAdvancedsearchs) {
                        headerFormIconAdvancedsearchs.style.display = 'none';
                    }
                    headerIntroTopForm.classList.add('header__intro-form-pk--active');
                    headerFormSearchClose.classList.add('active');
                } else {
                    headerIntroTopForm.classList.remove('header__intro-form-pk--active')
                    headerFormSearchClose.classList.remove('active');
                    if (headerFormIconAdvancedsearchs) {
                        headerFormIconAdvancedsearchs.style.display = 'block';
                    }
                }
            });
        }

    }

    // Закрытия поиска в не элемента
    document.addEventListener('click', (e) => {
        const headerSearch = document.querySelector('.header__intro-top');
        if (e.target.closest('.header__intro-top')) return;
        // clearTimeout(intervalSearchPrintText);
        if (headerSearch) {
            headerSearch.classList.remove('header__intro-form-pk--active');
            headerSearch.querySelector('.header__intro-form-input').value = '';
        }
        if(headerIntroFormInput) headerIntroFormInput.placeholder = 'Поиск по товарам, категориям и ГОСТ';
        if(headerFormSearchClose) headerFormSearchClose.classList.remove('active');
        if (headerFormIconAdvancedsearchs) headerFormIconAdvancedsearchs.style.display = 'block';
    });
    // Закрытия поиска в не элемента

    // Очистить инпут по нажатию на крестик в поиске
    if (headerFormSearchClose) {
        headerFormSearchClose.addEventListener('click', (e) => {
            const headerIntroForm = e.target.closest('.header__intro-top');
            const headerFormInput = headerIntroForm.querySelectorAll('.header__intro-form-input');

            if (headerFormInput[0]) {
                if (headerFormInput[0].value !== '') {
                    headerFormInput[0].value = '';
                    clearTimeout(intervalSearchPrintText);
                    headerFormInput[0].placeholder = '';
                    headerFormInput[0].focus();
                } else {
                    headerIntroForm.classList.remove('header__intro-form-pk--active');
                    headerFormSearchClose.classList.add('active');
                    headerIntroFormInput.focus();
                    headerFormSearchClose.classList.remove('active');
                    headerFormIconAdvancedsearchs.style.display = 'block';
                }
            }

            if (headerFormInput[1]) {
                if (headerFormInput[1] !== '') {
                    headerFormInput[1].value = '';
                    clearTimeout(intervalSearchPrintText);
                    headerFormInput[1].placeholder = '';
                    headerFormInput[1].focus();
                }
            }

        });
    }
    // Очистить инпут по нажатию на крестик в поиске

    // form--background-active резальт на 991px и меньше
    if (mediaMaxQueryForm.matches) {
        console.log("mediaMaxQueryForm.matches")
        function resultForms(e) {
            const headerIntroTopForm = e.target.closest('.header__intro-top');
            headerIntroTopForm.classList.add('header__intro-form--active');
            overlowFormBackground.classList.add('form--background-active');
            headerFormArrowBack.style.display = 'none';
            clearTimeout(intervalSearchPrintText);
            headerFormArrowCloseResult.style.display = 'block';
            headerIntroFormInput.placeholder = '';
            headerIntroFormInput.focus();
            if (headerIntroTopForm.querySelectorAll('.header__intro-form-input')[1]) {
                headerIntroTopForm.querySelectorAll('.header__intro-form-input')[1].placeholder = '';
                headerIntroTopForm.querySelectorAll('.header__intro-form-input')[1].focus();
            }
            headerFormSearchClose.classList.add('active');
            body.classList.add('hidden');
        }

        if (categoriesSearchBtnIcon) categoriesSearchBtnIcon.addEventListener('click', e => resultForms(e));
        console.log("categoriesSearchBtnIcon")
        if (headerIntroFormInput) {
            headerIntroFormInput.addEventListener('click', e => resultForms(e));
        }

        // Закрывает поисковой результат на mobile
        if (headerFormArrowCloseResult) {
            headerFormArrowCloseResult.addEventListener('click', (e) => {
                const formInput = headerIntroFormInput.closest('.header__intro-top');
                formInput.classList.remove('header__intro-form--active');
                overlowFormBackground.classList.remove('form--background-active');
                headerIntroFormInput.value = '';
                headerIntroFormInput.placeholder = 'Поиск по товарам, категориям и ГОСТ';
                headerFormSearchClose.classList.remove('active');
                body.classList.remove('hidden');
                headerFormArrowBack.style.display = 'block';
                headerFormArrowCloseResult.style.display = 'none';
                console.log(formInput.querySelector('.header__intro-top--arrow'));
            });
        }
    }
    // form--background-active
    // end search form










    // begin showMore "показывает больше текста"
    const btnShowMore = document.querySelectorAll('.js--btn-show');
    for (const btn of btnShowMore) {
        btn.addEventListener('click', (e) => {
            const contentWrapLeft = e.target.closest('.chapter__content--left').querySelector('.chapter__content--left--wrap');
            if (!contentWrapLeft.classList.contains('is--height')) {
                contentWrapLeft.classList.add('is--height');
                btn.classList.add('active');
                btn.textContent = 'Скрыть';
            } else {
                contentWrapLeft.classList.remove('is--height');
                btn.classList.remove('active');
                btn.textContent = 'Показать больше';
            }
        });
    }
    // end showMore "показывает больше текста"










    // begin position fixed-block content
    if (mediaMaxChapterFixed.matches) {
        if (mediaMaxChapterFixed) {
            if (btnShowMore) {
                for (const btn of btnShowMore) {
                    btn.addEventListener('click', (e) => {
                        const chapterContent = e.target.closest('.chapter__content');
                        const chapterContentFixed = chapterContent.querySelector('.chapter__content--fixed');
                        const chapterContentLeft = chapterContent.querySelector('.chapter__content--left');

                        const chapterContentHeight = chapterContentLeft.offsetHeight;
                        const chapterContentOffsetTop = chapterContent.offsetTop + 100;

                        if (btn.classList.contains('active')) {
                            document.addEventListener('scroll', () => {
                                let scrollDistance = window.scrollY;
                                if (scrollDistance > chapterContentOffsetTop) {
                                    chapterContentFixed.classList.add('fixed');
                                    chapterContentFixed.classList.remove('absolute');
                                } else {
                                    chapterContentFixed.classList.remove('fixed');
                                }
                                if (scrollDistance > chapterContentOffsetTop + chapterContentHeight - chapterContentFixed.offsetHeight) {
                                    chapterContentFixed.classList.add('absolute');
                                    chapterContentFixed.classList.remove('fixed');
                                }
                            });
                        } else {
                            chapterContentFixed.classList.remove('fixed');
                            document.addEventListener('scroll', () => {
                                chapterContentFixed.classList.remove('fixed');
                            });
                        }
                    });
                }
            }
        }
    }
    // end position fixed-block content









    // begin Меняется контент по времени
    const menubottomIconPhone = document.querySelector('.menubottom__icon--phone');
    const formTimeBlock = document.querySelector('.blocktime-time');
    const formTimeCatalog = document.querySelector('.section-catalogform');
    const formSectionTime = document.querySelector('.section-time');

    function headerTitle(headerText) {
        const headerTitle = document.createElement('h2');
        headerTitle.classList.add('visyal-hidden');
        headerTitle.textContent = headerText;
        return headerTitle;
    }

    if (formTimeBlock && formSectionTime) {
        const callusProd = document.querySelector('.callus-prod');
        const writetousProd = document.querySelector('.writetous-prod');
        const time = new Date();
        const hours = time.getHours();

        if (hours >= 8 && hours < 18) {
            formSectionTime.innerHTML = '';
            formTimeBlock.classList.remove('visyal-hidden');
            formSectionTime.classList.add('visyal-hidden');
            formTimeBlock.querySelector('h2')?.remove()
            formSectionTime.append(headerTitle('Введите номер телефона, перезвоним когда вам будет удобно!'));
            if (writetousProd) {
                writetousProd.style.display = 'none';
            }
            if (callusProd) {
                callusProd.style.display = 'block';
            }
            
        } else {
            formTimeBlock.innerHTML = '';
            formSectionTime.classList.remove('visyal-hidden');
            formTimeBlock.classList.add('visyal-hidden');
            formSectionTime.querySelector('h2')?.remove()
            formTimeBlock.append(headerTitle('Введите номер телефона, и мы перезвоним вам за 45 секунд!'));
            if (writetousProd) {
                writetousProd.style.display = 'block';
            }
            if (callusProd) {
                callusProd.style.display = 'none';
            }
        }
    }

    if (formTimeBlock && formTimeCatalog) {
        const time = new Date();
        const hours = time.getHours();

        let originalTimeBlockContent = formTimeBlock.innerHTML;
        let originalTimeCatalogContent = formTimeCatalog.innerHTML;

        if (hours >= 8 && hours < 18) {

            formTimeCatalog.innerHTML = '';
            formTimeCatalog.style.display = 'none';
            formTimeBlock.innerHTML = originalTimeBlockContent;

            formTimeBlock.querySelector('.blocktime_2').addEventListener('click', () => {
                formTimeBlock.querySelector('.blocktime_2').value = '7'
            });

            formTimeCatalog.append(headerTitle('Оформим заказ?'));

        } else {
            formTimeBlock.innerHTML = '';
            formTimeBlock.style.display = 'none';
            formTimeCatalog.innerHTML = originalTimeCatalogContent;

            formTimeCatalog.querySelector('.catalogform__input').addEventListener('click', () => {
                formTimeCatalog.querySelector('.catalogform__input').value = '7'
            });

            formTimeBlock.append(headerTitle('Введите номер телефона, и мы перезвоним вам за 45 секунд!'));
        }
    }

    if (menubottomIconPhone) {
        document.addEventListener('click', (e) => {
            const btnModal = e.target.closest('.menubottom__btn');
            if (btnModal) {
                const modalBtnOrder = btnModal.closest('.modalBtn').closest('body').querySelector('.modalOrderMobile');
                modalBtnOrder.classList.add('show');
                overlowShow();
            }
        });

        const menubottomLink = menubottomIconPhone.closest('.menubottom__link');

        const menubottomIconSpan = menubottomLink.querySelector('.menubottom__link-text');
        const menubottomSvg = menubottomIconPhone.querySelector('.menubottom__icon-svg');


        const time = new Date();
        const hours = time.getHours();

        if (hours >= 8 && hours < 18) {
            menubottomLink.href = 'tel:+74951507797';
            menubottomIconPhone.src = '/images/icon/icon-phone--menubottom.svg';
            menubottomIconPhone.alt = 'Звонок';
            menubottomIconSpan.textContent = 'Звонок';
        } else {
            const button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.classList.add('menubottom__btn');
            menubottomLink.prepend(button);
            button.prepend(menubottomIconPhone);
            menubottomSvg.innerHTML = '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<circle cx="18" cy="18" r="18" fill="url(#paint0_linear_6533_7484)"/>\n' +
                '<path d="M18 12V24M24 18L12 18" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                '<defs>\n' +
                '<linearGradient id="paint0_linear_6533_7484" x1="33.8824" y1="2.08266e-06" x2="6.88235" y2="36" gradientUnits="userSpaceOnUse">\n' +
                '<stop stop-color="#94E62C"/>\n' +
                '<stop offset="1" stop-color="#21D958"/>\n' +
                '</linearGradient>\n' +
                '</defs>\n' +
                '</svg>\n'; // new
            menubottomIconSpan.textContent = 'Заказать'; // new
            menubottomLink.classList.add('modalBtn');
            menubottomLink.setAttribute('data-modalBtn', '10');

            const paragraph = document.createElement('p');
            paragraph.classList.add('menubottom__link', 'menubottom-time', 'menubottom__icon--phone-c', 'd-justify-items-center', 'modalBtn')
            paragraph.setAttribute('data-modalbtn', '10')
            paragraph.innerHTML = menubottomLink.innerHTML;
            menubottomLink.parentNode.replaceChild(paragraph, menubottomLink);
        }

        // Анимация иконки на mobile
        if (menubottomIconPhone.closest('.menubottom__icon--phone-c').querySelector('.menubottom__link-text').textContent == 'Звонок') {
            setInterval(() => menubottomIconPhone.classList.remove('animPhone'), 2000);
            setInterval(() => menubottomIconPhone.classList.add('animPhone'), 20000);
        }

        // if (menubottomIconPhone.closest('.menubottom__icon--phone-c').querySelector('.menubottom__link-text').textContent == 'Заказать') {
            // setInterval(() => menubottomIconPhone.classList.remove('animPluse'), 2000);
            // setInterval(() => menubottomIconPhone.classList.add('animPluse'), 5000);
        // }
        // Анимация иконки на mobile
    }
    // end Меняется контент по времени












    // begin Страница категорий
    const sortBtnMobile = document.getElementById('sort-btn');
    const filterBtnMobile = document.querySelectorAll('.js-filter-btn');
    const sortCategoriesModalMobile = document.querySelector('.js-sort-categories');
    const filterCategoriesModalMobile = document.querySelector('.js-filter-categories');
    const filterCategoriesCloseMobile = document.querySelector('.js-filter-close');
    const filterCategoriesSelect = document.querySelectorAll('.js-categories__filter-select');
    const jsSearchSilterSelects = document.querySelectorAll('.js-search__filter-select');
    const categoriesPagination = document.querySelector('.categories__footer--pagination--content');
    let flagSelectShowContent = true;

    // По клику на кнопку сорт (Открывается сорт контент)
    if (sortBtnMobile) {
        sortBtnMobile.addEventListener('click', () => {
            sortCategoriesModalMobile.classList.add('sort--show');
            overlowShow();
            body.style.paddingRight = '0px';
        });
    }

    // По клику на кнопку фильтр (Открывается фильтр контент)
    if (filterBtnMobile) {
        filterBtnMobile.forEach(el => {
            el.addEventListener('click', () => {
                console.log(el)
                filterCategoriesModalMobile.classList.add('filter--show');
                overlowShow();
            });
        });
    }

    // По клику на крестик закрывает (фильтр контент)
    if (filterCategoriesCloseMobile) {
        filterCategoriesCloseMobile.addEventListener('click', () => {
            filterCategoriesModalMobile.classList.remove('filter--show');
            overlowHide();
            body.style.paddingRight = '';
        });
    }

    // По клику фильтров, отрывается и закрывается контен фильтров
    if (filterCategoriesSelect) {
        for (const filterSelect of filterCategoriesSelect) {
            filterSelect.addEventListener('click', () => {
                for (const filterSelect of filterCategoriesSelect) {
                    if (filterSelect.classList.contains('filter__select--show')) {
                        filterSelect.classList.remove('filter__select--show');
                    }
                }
                filterSelect.classList.add('filter__select--show');

                if (flagSelectShowContent) {
                    filterSelect.classList.add('filter__select--show');
                    flagSelectShowContent = false;
                } else {
                    filterSelect.classList.remove('filter__select--show');
                    flagSelectShowContent = true;
                }

            });
        }

        // Фильтры на странице расширенный поиск
        jsSearchSilterSelects.forEach(el => {
            el.addEventListener('click', (e) => {
                for (const select of jsSearchSilterSelects) {
                    if (select.classList.contains('filter__select--show')) {
                        select.classList.remove('filter__select--show');
                    }
                }
                el.classList.add('filter__select--show');
            });
        });

        // Скрывает открытый фильтр селект в не элемента
        document.addEventListener('click', (e) => {
            filterCategoriesSelect.forEach(el => {
                if (!e.target.closest('.categories__filter-tbody') || e.target.closest('.categories__filter-search')) {
                    flagSelectShowContent = true;
                    el.classList.remove('filter__select--show');
                }
            });
            jsSearchSilterSelects.forEach(el => {
                if (!e.target.closest('.categories__filter-view') || e.target.closest('.categories__filter-search')) {
                    el.classList.remove('filter__select--show');
                }
            });
        });
    }

    // Открывает / Закрывает пагинацию
    if (categoriesPagination) {
        categoriesPagination.addEventListener('click', (e) => {
            const paginationTextNumber = e.target.closest('.categories__footer--pagination--item');
            const paginationBtn = categoriesPagination.querySelector('.categories__footer--pagination--btn span');
            categoriesPagination.classList.toggle('categories__footer--pagination--active');
            if (paginationTextNumber) { // При нажатие на цифры в пагинации попадает в btn
                paginationBtn.textContent = paginationTextNumber.textContent;
                categoriesPagination.classList.remove('categories__footer--pagination--active');
                sort_click()
            }
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.categories__footer--pagination--content')) {
                categoriesPagination.classList.remove('categories__footer--pagination--active');
            }
        });

    }














    // begin Выбор Вида показа контента
    const filterViewItems = document.querySelectorAll('.filter__view-item');
    const categoriesContentsBlock = document.querySelectorAll('.categories__content-block');
    const filterViewItemsMobile = document.querySelectorAll('.filter__view-imgs-item');

    const categoriesTable = document.querySelector('.js-mobile-none');
    const categoriesList = document.querySelector('.js-mobile-show');
    if (categoriesTable) {
        if (mediaMinChapterFixed.matches) {
            categoriesTable.style.display = 'none';
            categoriesTable.classList.remove('show');
            categoriesList.classList.add('show');
            filterViewItems[1].classList.add('filter__view-item--active');
        }
    }

    // begin Активные иконки (Виды показа Mobile)
    if (filterViewItemsMobile) {
        for (const viewItemMobile of filterViewItemsMobile) {
            viewItemMobile.addEventListener('click',() => {
                for (const viewItemMobile of filterViewItemsMobile) {
                    viewItemMobile.classList.remove('filter__view-imgs-item--active');
                }
                viewItemMobile.classList.add('filter__view-imgs-item--active');
                contentShow(viewItemMobile);
            });
        }
    }
    // end Активные иконки (Виды показа Mobile)

    // begin Активные иконки (Виды показа Desktop)
    for (const viewItem of filterViewItems) {
        viewItem.addEventListener('click', () => {
            for (const viewItem of filterViewItems) {
                viewItem.classList.remove('filter__view-item--active');
            }
            viewItem.classList.add('filter__view-item--active');
            contentShow(viewItem);
        });
    }
    // end Активные иконки (Виды показа Desktop)
    // begin Выбор Вида показа контента




    // begin Переключения контента по нажатию иконок показа (Desktop & Mobile)
    function contentShow(viewItem) {
        const dataIcon = +viewItem.dataset.icon;
        for (const contentBlock of categoriesContentsBlock) {
            const dataContent = +contentBlock.dataset.content;
            const dataContentMobile = +contentBlock.dataset.contentMobile;
            contentBlock.classList.remove('categories__cards', 'show');
            if (dataIcon === dataContent) {
                console.log(dataIcon)
                categoryCookie(dataIcon)
                contentBlock.classList.add('show');
                if (filterCategoriesModalMobile) {
                    filterCategoriesModalMobile.classList.remove('filter--show');
                }
                overlowHide();
            } else {
                contentBlock.classList.remove('show');
            }
            if (dataIcon === dataContentMobile) {
                contentBlock.classList.add('categories__cards', 'show');
                if (filterCategoriesModalMobile) {
                    filterCategoriesModalMobile.classList.remove('filter--show');
                }
                overlowHide();
            }
        }
    }
    // end Переключения контента по нажатию иконок показа (Desktop & Mobile)
    // end Выбор Вида показа контента
    // end Страница категорий








    // begin Страница продукт - Переключения выбора товара (характеристики)
    const specificationsChoiceItemWrap = document.querySelectorAll('.specifications-choice-item-wrap');
    specificationsChoiceItemWrap.forEach(el => {
        el.addEventListener('click', (e) => {
            const choiceBtn = el.querySelectorAll('.specifications-choice-btn');
            choiceBtn.forEach(el => {
                el.classList.remove('specifications-choice-btn--active');
                e.target.classList.add('specifications-choice-btn--active');
            });
        });
    });
    // end Страница продукт - Переключения выбора товара (характеристики)












    // begin Страница продукт - Слайдер
    const jsProductImages = document.querySelector('.js-product-images');
    if (jsProductImages) {

        const sliderImagesSmalls = jsProductImages.querySelectorAll('.products__images-small-item');
        const sliderImagesBig = jsProductImages.querySelector('.products__images-big--item');
        const btnRight = document.querySelector('.new__content-arrow-right');
        const btnLeft = document.querySelector('.new__content-arrow-left');
        const sliderImagesSmallTrack = jsProductImages.querySelector('.products__images-small');
        const sliderBtn = document.querySelector('.products__images-arrows');
        const sliderBtnDown = jsProductImages.querySelector('.products__arrows-btn--down');
        const sliderBtnUp = jsProductImages.querySelector('.products__arrows-btn--up');

        let countImgBig = 0;
        let countImgSmall = 0;
        let heightImgSmall = 0;

        heightImgSmall = Math.round(sliderImagesSmallTrack.getBoundingClientRect().height / 4.5);

        function btnUpHidden() {
            sliderBtnUp.style.opacity = '0';
            sliderBtnUp.style.cursor = 'auto';
            sliderBtnUp.style.visibility = 'hidden';
        }

        function btnUpShow() {
            sliderBtnUp.style.opacity = '1';
            sliderBtnUp.style.cursor = 'pointer';
            sliderBtnUp.style.visibility = 'visible';
        }

        function btnDownHidden() {
            sliderBtnDown.style.opacity = '0';
            sliderBtnDown.style.cursor = 'auto';
            sliderBtnDown.style.visibility = 'hidden';
        }

        function btnDownShow() {
            sliderBtnDown.style.opacity = '1';
            sliderBtnDown.style.cursor = 'pointer';
            sliderBtnDown.style.visibility = 'visible';
        }

        // ** Показ и скрытия видео **
        const productBigWrap = document.querySelector('.new__content-right-track');
        const productsVideo = document.querySelectorAll('.products__video');
        function videoSliderProductShow() {
            productsVideo.forEach(el => {
                el.style.display = 'block';
                el.querySelector('video').play();
                el.querySelector('video').setAttribute('controls', '');
            });

            if(productBigWrap) {
                productBigWrap.style.cssText = `
                        height: 100%;
                        background-color: #242424;
                        border-radius: 14px;
                    `;
                productBigWrap.style.height = '100%';
            }
            sliderImagesBig.style.display = 'none';
        }

        function videoSliderProductHide() {
            productsVideo.forEach(el => {
                el.style.display = 'none';
                el.querySelector('video').pause();
                el.querySelector('video').removeAttribute('controls');
            });
            if(productBigWrap) {
                productBigWrap.style.cssText = ``;
            }
            sliderImagesBig.style.display = 'block';
        }

        // // Показ и скрытия видео //

        btnUpHidden();

        if (sliderImagesSmalls.length < 5) sliderBtn.style.display = 'none';

        function sliderSmallTrack() {
            sliderImagesSmallTrack.style.transform = `translate3d(0px, -${heightImgSmall * countImgSmall}px, 0px)`;
        }

        sliderImagesSmalls.forEach((el, i) => {
            el.addEventListener('mouseenter', ( {target} ) => {

                const imgBig = sliderImagesBig.querySelector('source');
                
                const imgSmallSrc = target.querySelector('img').dataset.img;
                const imgSmallSrc2 = target.querySelector('img').dataset.img2;
                const videoSmallSrc = target.querySelector('img').dataset.video;

                sliderImagesSmalls.forEach(element => element.classList.remove('products__images-small--active'));
                el.classList.add('products__images-small--active');

                if (imgSmallSrc) {
                    console.log('imgSmallSrc', imgSmallSrc)
                    console.log("imgSmallSrc2:" + imgSmallSrc2)
                }

                if (sliderImagesSmalls.length > 3) {
                        //begin Изменяет css свойтва в первом большом слайде
                        if (i === 0) {
                            sliderImagesBig.querySelector('img').style.cssText = `
                                object-fit: cover;
                            `;
                        } else if (i === 2) {
                            sliderImagesBig.querySelector('img').style.cssText = `
                                object-fit: contain;
                                height: auto;
                                aspect-ratio: auto;
                                transform: translateY(7px);
                            `;

                        } else {
                            sliderImagesBig.querySelector('img').style.cssText = `
                                object-fit: cover;
                            `;
                        }
                    } else {
                        if (i === 1) {
                            sliderImagesBig.querySelector('img').style.cssText = `
                                object-fit: contain;
                                height: auto;
                                aspect-ratio: auto;
                                transform: translateY(7px);
                            `;
                        } else {
                            sliderImagesBig.querySelector('img').style.cssText = `
                                object-fit: cover;
                            `;
                        }
                    }
                


                
                //end Изменяет css свойтва в первом большом слайде
                countImgBig = i;
                imgBig.srcset = imgSmallSrc;

                // ** Видео **
                videoSmallSrc ? videoSliderProductShow() : videoSliderProductHide();
                // // Видео //

                if (jsProductImages.querySelector('.slider--two')) {
                    jsProductImages.querySelector('.slider--two').querySelector('source').srcset = imgSmallSrc2;
                }

                i === 0 ? sliderImagesSmallTrack.style.transform = `translate3d(0px, -${0}px, 0px)` : '';
            });
        });


        // New slider
        function slideActive(smallSlider) {
            const smallImg = smallSlider[countImgBig].querySelector('img').dataset.img;
            const smallImg2 = smallSlider[countImgBig].querySelector('img').dataset.img2;
            const imgBig = sliderImagesBig.querySelector('source');

            smallSlider.forEach(el => el.classList.remove('products__images-small--active'));
            smallSlider[countImgBig].classList.add('products__images-small--active');

            imgBig.srcset = smallImg;
        }

        function sliderBtnRight() {
            if (btnRight) {
                btnRight.addEventListener('click', ({target}) => {
                    const smallSlider = target.closest('.products__images').querySelectorAll('.products__images-small-item');
                    countImgBig++;
                    countImgBig > sliderImagesSmalls.length - 1 ? countImgBig = 0 : '';

                    // ** Видео **
                    const videoClass = document.querySelectorAll('.new__content-right-track');
                    videoClass.forEach(el => {
                        if (el.classList.contains('videoClass')) {
                            countImgBig == 2 ? videoSliderProductShow() : videoSliderProductHide();
                        }
                    });
                    // // Видео //

                    slideActive(smallSlider);
                    btnUpShow();
                });
            }
        }

        function sliderBtnLeft() {
            if (btnLeft) {
                btnLeft.addEventListener('click', ({target}) => {
                    const smallSlider = target.closest('.products__images').querySelectorAll('.products__images-small-item');
                    countImgBig--;
                    countImgBig < 0 ? countImgBig = sliderImagesSmalls.length - 1 : '';

                    // ** Видео **
                    const videoClass = document.querySelectorAll('.new__content-right-track');
                    videoClass.forEach(el => {
                        if (el.classList.contains('videoClass')) {
                            countImgBig == 2 ? videoSliderProductShow() : videoSliderProductHide();
                        }
                    });
                    // // Видео //

                    slideActive(smallSlider);
                    btnUpShow()
                });
            }
        }

        sliderBtnRight();
        sliderBtnLeft();
        // New slider

        sliderBtnDown.addEventListener('click', () => {
            countImgSmall++;
            countImgSmall >= 1 ? btnUpShow() : '';

            sliderSmallTrack();

            if (countImgSmall > sliderImagesSmalls.length - 6) {
                btnDownHidden();
                sliderImagesSmallTrack.style.transform = `translate3d(0px, -${heightImgSmall * countImgSmall + 30}px, 0px)`;
            }

        });

        sliderBtnUp.addEventListener('click', () => {
            countImgSmall--;
            btnDownShow();
            countImgSmall < 1 ? btnUpHidden() : '';
            sliderSmallTrack();
        });


        // Автоматический слайдер
        if (mediaMaxChapterFixed.matches) {
            console.log("втоматический слайдер")
            // const productsImagesWrap = document.querySelector('.products__images');
            const productsImagesSmall = document.querySelector('.products__images-left');
            const productsImagesBig = document.querySelector('.products__images-right');
            const spiners = document.querySelectorAll('.sp');

            let autoSlideInterval;
            let indexAutoSlide = 0;
            // let indexHeight = 0;

            // Завершает autoSlide
            const autoSlideStop = () => {
                if (sliderImagesSmalls.length <= 2) return;
                clearInterval(autoSlideInterval);
                if (spiners.length >= 2) {
                    spiners[0].classList.remove('sp1');
                    spiners[1].classList.remove('sp2');
                }
                
            }

            productsImagesSmall.addEventListener('mouseover', () => {
                autoSlideStop();
                indexAutoSlide = 2
            });

            productsImagesBig.addEventListener('mouseover', () => {
                if (indexAutoSlide === 0)  autoSlideStop();
            });


            productsImagesBig.addEventListener('mouseout', () => {
                if (indexAutoSlide < 2) delayAutoSlide();
            });


            // Удаляет активный класс на всех мини картинках
            const autoSlideRemoveClass = () => {sliderImagesSmalls.forEach(el => el.classList.remove('products__images-small--active'))};

            // countImgSmall
            const delayAutoSlide = () => {
                const productsImagesBig = document.querySelector('.products__images-right');
                const bigPlan = productsImagesBig.querySelector('img');
                
                if (sliderImagesSmalls.length <= 2) return;
                if (spiners.length >= 2) {
                    spiners[0].classList.add('sp1');
                    spiners[1].classList.add('sp2');
                }
                
                autoSlideInterval = setInterval(() => {
                    console.log("3333 слайдер")
                    autoSlideRemoveClass();
                    indexAutoSlide++;

                    if (indexAutoSlide === 3) {
                        indexAutoSlide = 4;
                    }

                    if (sliderImagesSmalls.length > 3) {
                        if (indexAutoSlide === 2) {
                            bigPlan.style.cssText = `
                                object-fit: contain;
                                height: auto;
                                aspect-ratio: auto;
                                transform: translateY(7px);
                            `;
                        } else {
                            bigPlan.style.cssText = `
                                object-fit: cover;
                            `;
                        }
                    } else {
                        if (indexAutoSlide === 1) {
                            bigPlan.style.cssText = `
                                object-fit: contain;
                                height: auto;
                                aspect-ratio: auto;
                                transform: translateY(7px);
                            `;
                        } else {
                            bigPlan.style.cssText = `
                                object-fit: cover;
                            `;
                        }
                    }

                    if (indexAutoSlide === 0) {
                        productsImagesBig.addEventListener('mouseover', () => {
                            autoSlideStop();
                        });
                    }

                    if (indexAutoSlide > 1) {
                        productsImagesBig.addEventListener('mouseover', () => {
                            autoSlideStop();
                        });
                    }

                    if (indexAutoSlide > sliderImagesSmalls.length - 1) {
                        indexAutoSlide = 0;
                        autoSlideStop();
                    }

                    sliderImagesSmalls[indexAutoSlide].classList.add('products__images-small--active');

                    const imgSmall = sliderImagesSmalls[indexAutoSlide].querySelector('img').dataset.img;
                    const sourceImgBig = sliderImagesBig.querySelector('source');
                    sourceImgBig.srcset = imgSmall;

                }, 8000);
            }

            setTimeout(() => {
                delayAutoSlide();
            }, 500);
        }
        // Автоматический слайдер
    }
    // end Страница продукт - Слайдер






    // begin Показывает информационный блок!!!
    const tooltips = document.querySelectorAll('.tooltip');
    tooltips.forEach(el => {
        el.addEventListener('click', (e) => {
            const tooltip = e.target.closest('.tooltip');
            if (e.target.closest('.tooltip__wrap')) return;
            tooltip.classList.toggle('active');
        });
    });

    document.addEventListener('click', (e) => {
        tooltips.forEach(el => {
            const productsInfoBlock = el.parentElement.querySelector('.tooltip__wrap');
            console.log();
            if (!e.composedPath().includes(el) && !e.composedPath().includes(productsInfoBlock)) {
                el.classList.remove('active')
            }
        });
    })
    // end Показывает информационный блок!!!









    // begin слайдер отзывы
    const reviews = document.querySelector('.reviews')
    if (reviews) {
        const reviewsContentItem = document.querySelectorAll('.reviews__card');
        const reviewsDescSpan = document.querySelectorAll('.reviews__content-description--dop');
        const reviewsHeaderTitle = document.querySelectorAll('.reviews__header-title');
        const reviewsContent = document.querySelectorAll('.reviews__content');
        const sliderImagesWrap = document.querySelectorAll('.reviews__content-wrap');
        const sliderArrowRight = document.querySelector('.reviews__arrow-right');
        const sliderArrowLeft = document.querySelector('.reviews__arrow-left');

        reviewsContent[0].setAttribute('data-active', '');
        sliderImagesWrap[0].style.transform = `translate(0px, 0px)`;

        let widthCard = 0;
        let reviewsCountSlider = 0;
        let width = 0;
        let col = 0;

        // begin Переключения контента отзывов
        for (const title of reviewsHeaderTitle) {
            title.addEventListener('click', (e) => {
                const target = e.target;
                const dataItemReviews = +target.dataset.itemReviews;
                const reviewsHeader = target.closest('.reviews__header');
                const reviewsLinkTextReview = reviewsHeader.querySelector('.reviews__header-link--review');
                const reviewsLinkTextAllReview = reviewsHeader.querySelector('.reviews__header-link--allreview');

                for (const reviewsTitle of reviewsHeaderTitle) {
                    reviewsTitle.classList.remove('reviews__header-title--active'); // Удаляет активный класс reviews__header-title--active
                }

                title.classList.add('reviews__header-title--active');  // Добовляет активный класс reviews__header-title--active
                reviewsContentShou(dataItemReviews, reviewsLinkTextReview, reviewsLinkTextAllReview);
            });
        }

        function reviewsContentShou(dataItemReviews, reviewsLinkReview, reviewsLinkAllReview) {
            for (const content of reviewsContent) {
                const dataContent = +content.dataset.contentReviews;
                // Показывает активный контент
                // Меняет текст и ссылки
                if (dataItemReviews === dataContent) {
                    content.classList.add('reviews__content--show');
                    reviewsLinkReview.textContent = 'Задать вопрос';
                    reviewsLinkReview.setAttribute('data-modalBtn', '14');
                    reviewsLinkAllReview.textContent = 'Все вопросы';
                    reviewsLinkAllReview.href = 'question-answer-page.php';
                    content.setAttribute('data-active', '');
                    content.querySelector('.reviews__content-wrap').style.transform = `translate(0px, 0px)`;
                    reviewsCountSlider = 0;
                } else {
                    content.classList.remove('reviews__content--show');
                    reviewsLinkReview.textContent = 'Оставить отзыв';
                    reviewsLinkReview.setAttribute('data-modalBtn', '13');
                    reviewsLinkAllReview.textContent = 'Все отзывы';
                    reviewsLinkAllReview.href = 'reviews-page.php';
                    content.removeAttribute('data-active');
                    content.querySelector('.reviews__content-wrap').style.transform = '';
                    reviewsCountSlider = 0;
                }
            }
        }
        // Переключения контента отзывов

        mediaMaxChapterFixed.matches ?  col = 33 : col = 20;
        function reviewsSlide(cards) {
            cards.forEach(card => {
                widthCard = Math.round(card.getBoundingClientRect().width) + col;
                console.log(col);
                width = widthCard * reviewsCountSlider;
            });
        }

        function reviewsSliderScore() {
            width = widthCard * reviewsCountSlider;
        }

        function reviewsSliderTrack(reviewsContentWrap) {
            for (const wrap of reviewsContentWrap) {
                wrap.style.transform = `translate(-${width}px, 0px)`;
            }
        }

        sliderArrowLeft.addEventListener('click', (e) => {
            const reviews = e.target.closest('.reviews');
            const reviewsContent = reviews.querySelectorAll('.reviews__content');
            reviewsContent.forEach(el => {
                if (el.hasAttribute('data-active')) {
                    const cards = el.querySelectorAll('.reviews__card');
                    const reviewsContentWrap = el.querySelectorAll('.reviews__content-wrap');
                    reviewsCountSlider--;
                    reviewsSliderScore();
                    if (reviewsCountSlider < 0) {
                        reviewsCountSlider = cards.length - 3;
                    }
                    reviewsSlide(cards);
                    reviewsSliderTrack(reviewsContentWrap);
                }

            });
        });

        sliderArrowRight.addEventListener('click', (e) => {
            const reviews = e.target.closest('.reviews');
            const reviewsContent = reviews.querySelectorAll('.reviews__content');
            reviewsContent.forEach(el => {
                if (el.hasAttribute('data-active')) {
                    const cards = el.querySelectorAll('.reviews__card');
                    const reviewsContentWrap = el.querySelectorAll('.reviews__content-wrap');
                    reviewsCountSlider++;
                    reviewsSliderScore();
                    if (reviewsCountSlider > cards.length - 3) {
                        reviewsCountSlider = 0
                    }
                    reviewsSlide(cards);
                    reviewsSliderTrack(reviewsContentWrap);
                }

            });
        });
        // end переключения слайдера

        // begin Показывает текст (Читать далее... там где текста много)
        reviewsContentItem.forEach(el => {
            const lengthText = el.querySelectorAll('.reviews__card-description--length');
            lengthText.forEach(element => {
                if (element.textContent.length <= 200) {
                    element.closest('.reviews__card').querySelector('.reviews__content-description--dop').remove();
                }
            });
        });
        // end Показывает текст (Читать далее... там где текста много)

        reviewsDescSpan.forEach(el => {
            el.addEventListener('click', () => {
                const reviewsContentDescription = el.parentElement.closest('.reviews__card-description');
                const reviewsContentUserDesc = reviewsContentDescription.querySelector('.reviews__card-description--text');
                reviewsContentUserDesc.classList.toggle('open');
                reviewsContentUserDesc.classList.contains('open') ? el.textContent = 'Скрыть' : el.textContent = 'Читать далее...';
            });
        });
    }
    // end слайдер отзывы















    // begin content fixed блок
    function scrollfixedblock(fixedWrap, fixedBlock) {
        // const fixedContent = document.querySelector('.js-content-fixed-product');
        const fixedContent = document.querySelector(fixedWrap);
        if (fixedContent) {
            // const bascetFinalpriceFixed = fixedContent.querySelector('.js-track-fixed-product');
            const bascetFinalpriceFixed = fixedContent.querySelector(fixedBlock);
            const bascetContentOffsetTop = fixedContent.offsetTop + 100;

            document.addEventListener('scroll', () => {
                let scrollDistance = window.scrollY;

                scrollDistance > bascetContentOffsetTop ? bascetFinalpriceFixed.style.transform = `translate(0px, ${window.scrollY - bascetContentOffsetTop}px)` : bascetFinalpriceFixed.style.transform = `translate(0px, 0px)`;

                if (document.querySelector('.header__intro-wrap').classList.contains('active')) {
                    bascetFinalpriceFixed.style.position = 'relative';
                    bascetFinalpriceFixed.style.top = '90px';
                } else {
                    bascetFinalpriceFixed.style.position = '';
                    bascetFinalpriceFixed.style.top = '0px';
                }

                scrollDistance > fixedContent.offsetHeight - 400 ? bascetFinalpriceFixed.style.transform = `translate(0px, ${fixedContent.offsetHeight - bascetFinalpriceFixed.offsetHeight - 95}px)` : '';

            });
        }
    }

    if (mediaMaxChapterFixed.matches) {
        scrollfixedblock('.js-content-fixed', '.js-track-fixed');
    } else if ((window.matchMedia('(max-width: 992px)').matches < window.matchMedia('(max-width: 1200px)').matches)) {
        scrollfixedblock('.js-content-fixed-product', '.js-track-fixed-product');
    }
    // end content fixed блок







    // Страница Оформления заказа
    // Переключения контента (Форм) тыбы
    const orderregistrationTitle = document.querySelectorAll('.tab__content');
    // const tabIndicator = document.querySelector('.tab__indicator');
    const orderregistrationForm = document.querySelectorAll('.orderregistration__form');

    for (const title of orderregistrationTitle) {
        title.addEventListener('click', (e) => {
            for (const title of orderregistrationTitle) {
                title.classList.remove('orderregistration__top-item--active');
            }
            title.classList.add('orderregistration__top-item--active');
            switchTabs(+e.target.closest('.orderregistration__top-item').dataset.btn);
        });
    }

    function switchTabs(dataBtn) {
        for (const form of orderregistrationForm) {
            const dataForm = +form.dataset.form;
            if (dataBtn === dataForm) {
                form.classList.add('orderregistration__form-active');
            } else {
                form.classList.remove('orderregistration__form-active');
            }
        }
    }
    // Переключения контента (Форм) тыбы

    // begin Открывает модальное окно с картой
    const btnMaps = document.querySelectorAll('.btnMaps');
    const modalmaps = document.querySelector('.modalmaps');
    if (modalmaps) {
        for (const btn of btnMaps) {
            btn.addEventListener('click', () => {
                modalmaps.classList.add('show');
            });
        }
        document.addEventListener('keydown', (e) => {
            if (modalmaps.classList.contains('show')) {
                if (e.keyCode === 27) modalmaps.classList.remove('show');
            }
        });
    }
    // end Открывает модальное окно с картой
    // Страница Оформления заказа







    // begin Слайдер модального окна отзывы
    const reviewsWrapModal = document.querySelector('.productsmodal__reviews');
    if (reviewsWrapModal) {
        const smallImages = reviewsWrapModal.querySelectorAll('.js-reviews-modal-imgsmall');
        const bigImages = reviewsWrapModal.querySelectorAll('.js-reviews-modal-imgbig');
        const rightBtn = reviewsWrapModal.querySelector('.productsmodal__content-buttons--right');
        const leftBtn = reviewsWrapModal.querySelector('.productsmodal__content-buttons--left');
        const wrapBigTrack = reviewsWrapModal.querySelector('.productsmodal__content-image-big-content');

        const smallTrack = reviewsWrapModal.querySelector('.productsmodal__reviews-track');

        let index = 0;
        let widthSmallImage = 0;
        let heightSmallImages = 0;
        let countSmallImage = 0;

        function reviewsWrapTrack() {
            wrapBigTrack.style.transform = `translate3d(-${widthSmallImage * index}px, 0px, 0px)`;
            smallTrack.style.transform = `translate3d(0px, -${heightSmallImages * countSmallImage}px, 0px)`;
        }

        function bigImagesWidth() {
            bigImages.forEach(element => {
                widthSmallImage = element.offsetWidth;
            });
        }

        function smallImagesRemoveActive() {
            smallImages.forEach(el => {
                el.classList.remove('productsmodal__content-small--active');
            });
        }

        function smallImagesAddActive() {
            smallImages[index].classList.add('productsmodal__content-small--active');
        }

        smallImages.forEach((el, i) => {
            heightSmallImages = el.offsetHeight + 13;
            el.addEventListener('click', () => {
                smallImagesRemoveActive();
                bigImagesWidth();
                index = i;
                if (mediaMaxChapterFixed.matches) {
                    if (i < smallImages.length - 4) {
                        countSmallImage = i;
                    }
                }
                el.classList.add('productsmodal__content-small--active');
                reviewsWrapTrack();
            });
        });

        rightBtn.addEventListener('click', (e) => {
            index++;
            bigImagesWidth();
            smallImagesRemoveActive();

            if (index > bigImages.length - 1) index = 0;

            if (mediaMaxChapterFixed.matches) {
                if (smallImages.length > 4 && index > 4) {
                    countSmallImage++;
                } else {
                    smallTrack.style.transform = `translate3d(0px, 0px, 0px)`;
                    countSmallImage = 0;
                }
            }

            smallImagesAddActive();
            reviewsWrapTrack();
        });

        leftBtn.addEventListener('click', (e) => {
            index--;
            bigImagesWidth();
            if (index < 0) {
                index = bigImages.length - 1;
                countSmallImage = smallImages.length - 4;
            }
            countSmallImage--;
            smallImagesRemoveActive();
            smallImagesAddActive();
            reviewsWrapTrack();
        });
    }
    // end Слайдер модального окна отзывы










    // begin Страница reviews-feedback слайдер
    const reviewsfedbackBannerSlider = document.querySelector('.reviewsfedback__banner');
    if (reviewsfedbackBannerSlider) {
        const reviewsfedbackBannerSliderTrack = reviewsfedbackBannerSlider.querySelector('.reviewsfedback__banner-track');
        const reviewsfedbackBannerSliderImg = Array.from(reviewsfedbackBannerSlider.querySelectorAll('.reviewsfedback__banner-img'));
        const reviewsfedbackBannerDots = document.querySelector('.reviewsfedback__banner-dots');
        let reviewsfedbackBannerSliderCount = 0;
        let reviewsfedbackBannerSliderWidth = 0;
        let stopInterval;

        reviewsfedbackBannerSliderImg.forEach(el => {
            reviewsfedbackBannerSliderWidth = el.getBoundingClientRect().width;
            if (reviewsfedbackBannerSliderImg.length > 1) {
                const reviewsfedbackDotsItem = document.createElement('li');
                reviewsfedbackDotsItem.classList.add('reviewsfedback__banner-dot');
                reviewsfedbackBannerDots.appendChild(reviewsfedbackDotsItem);
            }
        });

        const reviewsfedbackDotItems = Array.from(reviewsfedbackBannerDots.querySelectorAll('.reviewsfedback__banner-dot'));
        reviewsfedbackDotItems[0].classList.add('active');

        function reviewsfedbackSliderBanner() {
            reviewsfedbackBannerSliderCount++;
            if (reviewsfedbackBannerSliderCount > reviewsfedbackBannerSliderImg.length - 1) {
                reviewsfedbackBannerSliderCount = 0;
            }
            for (const item of reviewsfedbackDotItems) {
                item.classList.remove('active');
            }
            reviewsfedbackDotItems[reviewsfedbackBannerSliderCount].classList.add('active');
            reviewsfedbackSliderTrack();
        }

        reviewsfedbackDotItems.forEach((element, i) => {
            element.addEventListener('click', () => {
                reviewsfedbackBannerSliderCount = i;
                reviewsfedbackDotItems.forEach(element => {
                    element.classList.remove('active');
                });
                element.classList.add('active');
                reviewsfedbackSliderTrack();
            });
        });

        function reviewsfedbackBannerTime() {
            stopInterval = setInterval(() => {
                reviewsfedbackSliderBanner();
            }, 5500);
        }

        reviewsfedbackBannerSlider.addEventListener('mouseover', () => {
            clearInterval(stopInterval);
        });

        reviewsfedbackBannerSlider.addEventListener('mouseout', () => {
            reviewsfedbackBannerTime();
        });

        function reviewsfedbackSliderTrack() {
            reviewsfedbackBannerSliderTrack.style.transform = `translate(${-reviewsfedbackBannerSliderWidth * reviewsfedbackBannerSliderCount}px, 0px)`;
        }

        reviewsfedbackBannerTime();
    }
    // end Страница reviews-feedback слайдер(banner)









    // begin Страница расширенный поиск (открытие/зыкрытие form)
    const headerSearchForm = document.querySelectorAll('.js-header__search-form');
    if (headerSearchForm) {
        const headerSearchInput = document.querySelectorAll('.header__search-input');
        const headerSearchContentOne = document.querySelectorAll('.header__search-form-content-one');
        const headerSearchIconArrow = document.querySelectorAll('.js-header__search-form-input-icon-arrow');
        const headerSearchLink = document.querySelectorAll('.header__search-form-content-item-link');

        headerSearchInput.forEach(el => {
            el.addEventListener('input', (e) => {
                const wrapHeaderSearch = e.target.closest('.js-header__search-form');
                const contentOne = wrapHeaderSearch.querySelector('.header__search-form-content-one');
                const contentAll = wrapHeaderSearch.querySelector('.header__search-form-content-all');
                const inputValue = e.target.value;

                headerSearchContentOne.forEach(el => {
                    el.classList.remove('show');
                });

                headerSearchInput.forEach(element => {
                    const wrapSearch = element.closest('.js-header__search-form');
                    if (wrapSearch.querySelector('.header__search-form-content-all')) {
                        wrapSearch.querySelector('.header__search-form-content-all').classList.remove('show');
                        wrapHeaderSearch.classList.remove('active-arrow');
                    }
                });

                contentAll.classList.remove('show');

                if (inputValue !== '') {
                    contentOne.classList.add('show');
                    wrapHeaderSearch.classList.add('active-arrow');
                } else {
                    contentOne.classList.remove('show');
                    wrapHeaderSearch.classList.remove('active-arrow');
                }


            });
        });

        headerSearchIconArrow.forEach(el => {
            el.addEventListener('click', (e) => {
                const wrapHeaderSearch = e.target.closest('.js-header__search-form');
                const contentOne = wrapHeaderSearch.querySelector('.header__search-form-content-one');
                const contentAll = wrapHeaderSearch.querySelector('.header__search-form-content-all');
                const input = wrapHeaderSearch.querySelector('.header__search-form-input');

                headerSearchIconArrow.forEach(el => {
                    const wrapHeaderSearch = el.closest('.js-header__search-form');
                    const contentAll = wrapHeaderSearch.querySelector('.header__search-form-content-all');
                    contentAll.classList.remove('show');
                    wrapHeaderSearch.classList.remove('active-arrow');
                });

                headerSearchContentOne.forEach(el => {
                    el.classList.remove('show');
                });

                contentOne.classList.remove('show');
                contentAll.classList.add('show');
                wrapHeaderSearch.classList.add('active-arrow');
                input.value = '';
            });
        });

        headerSearchLink.forEach(el => {
            el.addEventListener('click', (e) => {
                const wrapHeaderSearch = e.target.closest('.js-header__search-form');
                const text = e.target.textContent;
                const contentOne = wrapHeaderSearch.querySelector('.header__search-form-content-one');
                const contentAll = wrapHeaderSearch.querySelector('.header__search-form-content-all');
                const input = wrapHeaderSearch.querySelector('.header__search-form-input');

                contentOne.classList.remove('show');
                contentAll.classList.remove('show');
                wrapHeaderSearch.classList.remove('active-arrow');
                input.value = text;
                contentAll ? contentAll.classList.remove('show') : '';

            });
        });

        document.addEventListener('click', (e) => {
            headerSearchForm.forEach(el => {
                if (el.querySelector('.header__search-form-content-one').classList.contains('show')) {
                    el.querySelector('.header__search-form-content-one').classList.remove('show');
                    el.querySelector('.header__search-form-input').value = '';
                    el.classList.remove('active-arrow');
                }
                if (!e.target.closest('.js-header__search-form')) {
                    if (el.querySelector('.header__search-form-content-all')) {
                        el.querySelector('.header__search-form-content-all').classList.remove('show');
                        el.classList.remove('active-arrow');
                    }
                }
            });
        });

    }
    // end Страница расширенный поиск (открытие/зыкрытие form)








    // begin Копирование текста по нажатию иконки
    function copyToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        //textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.error('Не скопировал', err);
        }
        document.body.removeChild(textArea);
    }
    const imgCopyText = document.querySelectorAll('.js-copy-icon');
    imgCopyText.forEach(el => {
        el.setAttribute('title', 'Скопировать в буфер обмена');

        el.addEventListener('click', (e) => {
            const copyText = el.closest('.js-copy-text').textContent;
            if (!el.classList.contains('contacts__item-icon-white')) {
                for (const icon of imgCopyText) {
                    icon.classList.remove('contacts__item-icon-jackdaw', 'active');
                }
                el.classList.add('contacts__item-icon-jackdaw', 'active');
            } else {
                for (const icon of imgCopyText) {
                    if (icon.closest('.contacts__item-icon-white')) {
                        for (const icon of imgCopyText) {
                            icon.classList.remove('contacts__item-icon-jackdaw-white', 'active');
                        }
                    }
                }
                el.classList.add('contacts__item-icon-jackdaw-white', 'active');
            }
            copyToClipboard(copyText.trim())
        })
    });
    // end Копирование текста




















    // begin Поиск адреса (модальное окно карта) + select search
    const mapsSelectInput = document.querySelectorAll('.modalmaps__content-input');
    const mapsContentSelectContent = document.querySelectorAll('.modalmaps__content-select-content');
    const iconClosesInput = document.querySelectorAll('.modalmaps-icon--close');
    const mapsModalContentAddress = document.querySelector('.modalmaps__content-address');

    // Открывает/Закрывает список с адресами у инпута(адрес)
    mapsSelectInput.forEach(el => {
        el.addEventListener('input', ( {target} ) => {
            const inputValue = target.value;
            const modalContentWrap = target.closest('.wrapMapContent');
            const modalContent = modalContentWrap.querySelector('.modalmaps__content-select-content');
            const iconCloseInput = modalContentWrap.querySelector('.modalmaps-icon--close');

            if (inputValue !== '') {
                modalContent.classList.add('active');
                iconCloseInput.style.display = 'block';
            } else {
                modalContent.classList.remove('active');
                iconCloseInput.style.display = '';
            }
            listContentAddress();
        });
    });

    // Клик по крестику
    // Очищает поле инпута от текста и крестика
    iconClosesInput.forEach(el => {
        el.addEventListener('click', () => {
            for (const input of mapsSelectInput) {
                input.value = '';
                input.textContent = '';
            }
            el.parentElement.firstElementChild.value = '';

            iconClosesInput.forEach(element => {
                element.style.display = '';
            });
            mapsModalContentAddress.classList.remove('show');
        });
    });

    // Записывает в инпут адрес по клику по списку адресов
    function listContentAddress() {
        mapsContentSelectContent.forEach(el => {
            if (el.classList.contains('active')) {
                el.addEventListener('click', ( {target} ) => {
                    const contentLi = target.closest('li');
                    if (contentLi) {
                        const text = contentLi.querySelector('.modalmaps__content-select-content-list-one');

                        for (let i = 0; i < mapsSelectInput.length; i++) {
                            mapsSelectInput[i].textContent = text.textContent;
                            mapsSelectInput[i].value = text.textContent;
                            resetInput();
                            mapsModalContentAddress.classList.add('show');
                            console.log("sssssssssssss")

                        }

                        iconClosesInput.forEach(element => {
                            element.style.display = 'block';
                        });

                    }
                    if (target.closest('.modalmapsContent')) {
                        mapsModalContentAddress.classList.add('show');
                    }

                })
            }
        });
    }

    /*    // Кнопка добавления адреса в модальном окне
        document.querySelector('.modalmaps__content-address-btn').addEventListener('click', () => {
            const modalmaps = document.querySelector('.modalmaps');
            modalmaps.classList.remove('show');
        });*/

    // Закрывает контент с адресами в не элемента
    document.addEventListener('click', ( {target} ) => {
        if (!target.closest('.modalmaps__content-select-content') && !target.closest('.modalmaps-icon--close')) {
            resetInput();
        }
    });

    // Скрывает выпадающий список
    function resetInput() {
        for (let i = 0; i < mapsContentSelectContent.length; i++) {
            mapsContentSelectContent[i].classList.remove('active');
        }
    }
    // end Поиск адреса (модальное окно карта) + select search



    // begin Страница документов
    // begin ОТВЕТ ДА/НЕТ
    const modalsRadio = document.querySelectorAll('.modalRadio');
    const jsDocumentRadio = document.querySelectorAll('.js-document-radio');
    const modalRadioRadioInput = document.querySelectorAll('.modalRadio__radio-input');

    // Активный радио инпут (ДА/НЕТ)
    for (const radio of jsDocumentRadio) {
        radio.addEventListener('click', ( {target} ) => {
            const label = target.closest('.documents__content-bottom-button-label');
            for (const radio of jsDocumentRadio) {
                radio.classList.remove('active');
            }

            target.checked == true ? target.closest('.documents__content-bottom-button-label').classList.add('active') : '';

            if (label.classList.contains('active')) {
                openModal(label);
            }
        });
    }

    // Открывает/Скрывает textarea (если checked комментарий)
    modalRadioRadioInput.forEach(el => {
        el.addEventListener('change', (e) => {
            const modalRadioTextareaBlock = document.querySelector('.modalRadio__textarea__block');
            const check = document.querySelector('.modalRadio__radio.modalRadio__radio-border');

            if (e.target.value == 'comment') {
                modalRadioTextareaBlock.classList.add('active');
                check.style.borderTop = '1px solid #ddd';
                check.style.paddingTop = '9px';
            } else {
                modalRadioTextareaBlock.classList.remove('active');
                check.style.borderTop = ''
                check.style.paddingTop = ''
            }
        })
    });

    // Открывает модальное окно по ответу
    function openModal(label) {
        for (const modal of modalsRadio) {
            modal.classList.remove('show');
        }
        label.closest('.documents__content--item').querySelector('.modalRadio').classList.add('show');
    }

    // Закрывает по клику на крестик модальное окно
    for (const modal of modalsRadio) {
        modal.addEventListener('click', ( {target} ) => {
            if (!target.closest('.modalRadio__close')) {
                return;
            } else {
                modal.classList.remove('show');
            }
        })
    }

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.modalRadio__body') && !e.target.closest('.documents__content--item')) {
            modalsRadio.forEach(element => {
                element.classList.remove('show');
            });
        }
    });
    // end ОТВЕТ ДА/НЕТ

    // begin Табы (переключения контента)
    const doumentsTabsItem = document.querySelectorAll('.douments__tabs-item');
    for (const tab of doumentsTabsItem) {
        tab.addEventListener('click', () => {
            for (const tab of doumentsTabsItem) {
                tab.classList.remove('active');
            }
            tab.classList.add('active');
            switchTabs(tab);
        });
    }

    function switchTabs(tab) {
        const doumentstabsConten = document.querySelectorAll('.js-tabsContent');
        const dataTab = +tab.dataset.tab;

        for (const tabContent of doumentstabsConten) {
            tabContent.classList.remove('active');
        }

        for (const tabContent of doumentstabsConten) {
            const dataContent = +tabContent.dataset.content;

            if (dataContent === dataTab) {
                tabContent.classList.add('active')
            }
        }
    }
    // end Табы (переключения контента)

    // begin Навигация аккордион
    const documentAccordionWraps = document.querySelectorAll('.document__contentall');
    const documentAccordionContents = document.querySelectorAll('.document__content-open');
    for (let i = 0; i < documentAccordionWraps.length; i++) {
        const element = documentAccordionWraps[i];
        element.addEventListener('click', () => {
            const accordion = element.closest('.document__navigation-header');
            const accordionContents = accordion.querySelectorAll('.document__content-open');
            element.classList.toggle('open');
            for (const content of accordionContents) {
                content.classList.remove('open');
            }

        })
    }

    for (const content of documentAccordionContents) {
        content.addEventListener('click', () => {
            content.classList.toggle('open');
        });
    }
    // end Навигация аккордион
    // end Страница документов









    // begin skeletons
    const skeletons = document.querySelector('.skeletons');
    const containerFluid = document.querySelector('.container--fluid.container--fluid-skeletons');
    // containerFluid.style.display = 'none';

    const skeletonsInterval = setInterval(() => {
        // skeletons.style.display = 'none';
        // containerFluid.style.display = 'block';
        clearInterval(skeletonsInterval);
    }, 6000);
    // end skeletons









    // begin Страница разгрузите производство
    const addproductsBodyList = document.querySelector('.addproducts__body-bottom');
    const addproductsForm = document.querySelector('.addproducts__form');
    const addproductsBtnReset = document.querySelector('.addproducts__btn');
    const headerTextSale = document.querySelector('.headerTextSale');
    let nameCount = 0;

    let debounceTimeout = '';
    let currentSign = '%';
    function updateCurrentSign(sign) {
        currentSign = sign;
    }

    // Создают новые карточки
    function createCard() {
        nameCount++;
        const cardHTML = `
            <div class="addproducts__body-bottom-row js--addproducts__body-card">
                <div class="addproducts__body-bottom-item">
                    <span class="addproducts__body-name addproducts__body-name-mobile addproducts__body-name--margin">№</span>
                    <div class="addproducts__body--one d-align-items-center">
                        <div class="addproducts__body-bottom-number addproducts__body-bottom--border d-justify-items-center">1</div>
                        <div class="addproducts__body-bottom-loading addproducts__body-bottom--border d-justify-items-center">
                            <div class="file__form-field-wrap js-inputfile">
                                <div class="file__form-field">
                                    <input class="file__form-input file__form-input-file images" name="images[`+nameCount+`][]" multiple accept="image/png, image/jpeg" type="file">
                                    <label class="file__form-file-label file__form-file-label--icon"></label>
                                </div>
                                <span class="file__form-count">1</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="addproducts__body-bottom-item">
                    <span class="addproducts__body-name addproducts__body-name-mobile ">Наименование</span>
                    <input class="addproducts__inputReset desc" type="text" name="desc[]" autocomplete="none">
                </div>
                <div class="addproducts__body-bottom-item">
                <span class="addproducts__body-name addproducts__body-name-mobile">Кол-во</span>
                    <input class="addproducts__inputReset required quantity" type="text" placeholder="0" name="quantity[]">
                </div>
                <div class="addproducts__body-bottom-item">
                <span class="addproducts__body-name addproducts__body-name-mobile">Ед.</span>
                    <!-- <input type="text" placeholder="2"> -->
                    <!-- select -->
                    <div class="addproducts__body-bottom-select addproducts__select">
                        <div class="addproducts__select-wrap"> <!--open-->
                            <div class="addproducts__select-input">
                                <input class="addproducts__selectReset unit" type="text" value="шт" name="unit[]" readonly>
                            </div>
                            
                            <div class="addproducts__select-content">
                                <div class="addproducts__select-content-list scroll-show">
                                    <span data-text="шт">Штука</span>
                                    <span data-text="компл">Комплект</span>
                                    <span data-text="м">Метр</span>
                                    <span data-text="м2">Метр квадратный</span>
                                    <span data-text="м3">Метр кубический</span>
                                    <span data-text="меш">Мешок</span>
                                    <span data-text="рул">Рулон</span>
                                    <span data-text="упак">Упаковка</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- select -->
                </div>
                <div class="addproducts__body-bottom-item">
                <span class="addproducts__body-name addproducts__body-name-mobile">Цена</span>
                    <input class="addproducts__inputReset required price" type="text" placeholder="0" value="" name="price[]">
                </div>
                <div class="addproducts__body-bottom-item">
                    <span class="addproducts__body-name addproducts__body-name-mobile">Скидка ₽ / %</span>
                    <div class="addproducts__sale-item">
                        <input class="addproducts__sale-item-input addproducts__sale-item-input-bottom addproducts__inputReset salePrice" type="number" placeholder="0" name="sale[]">
                        <input class="addproducts__sale-item-badge addproducts__sale-item-badge-bottom saleName" type="text" value="${currentSign}" name="saleName[]" readonly>
                    </div>
                </div>
                <div class="addproducts__body-bottom-item">
                    <span class="addproducts__body-name addproducts__body-name-mobile">Цена со скидкой</span>
                    <input class="addproducts__inputReset required total" type="text" placeholder="0">
                </div>
                <div class="addproducts__body-bottom-item">
                    <div class="addproducts__body-bottom-item-add addproducts__btn-delete d-justify-items-center">
                        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4.2724H15M6.16765 14.904L5.75991 9.18208M9.63646 14.894L10.0687 9.17408M2.5555 4.2724H13.4444L12.3966 17.4998C12.3294 18.348 11.6554 19.0004 10.8464 19.0004H5.15348C4.34446 19.0004 3.67048 18.348 3.6033 17.4998L2.5555 4.2724ZM3.33319 4.2724H12.6665L12.0135 2.13519C11.8067 1.45843 11.2083 0.999512 10.5326 0.999512H5.46713C4.79141 0.999512 4.19297 1.45843 3.9862 2.13519L3.33319 4.2724Z" stroke="#8B8B8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        `;
        // <input type="hidden" value="" name="">
        // <span class="addproducts__sale-item-badge">₽</span>
        addproductsBodyList.insertAdjacentHTML('beforeend', cardHTML);
        clickProd();
    }

    // Удаляет/добавляет карточки + взаимодействия с самими карточками
    if (addproductsForm) {

        addproductsForm.addEventListener('click', ( {target} ) => {
            const btnAdd = target.closest('.addproducts__btn-add');
            const btnDelete = target.closest('.addproducts__btn-delete');
            const row = target.closest('.addproducts__body-bottom-row');

            const selects = addproductsBodyList.querySelectorAll('.addproducts__select-wrap');
            const selesctWrap = target.closest('.addproducts__select-wrap');
            const selesctContentListText = target.closest('.addproducts__select-content-list span');
            const inputFile = target.closest('.file__form-input-file');
            const badgeBottomInputTop = target.closest('.addproducts__sale-item-badge-top');
            const badgeBottomInputBottom = target.closest('.addproducts__sale-item-badge-bottom');
            const inputText = target.closest('.addproducts__sale-item-input-top');

            const modalHintTotal = target.closest('body').querySelector('.modalHintTotal');
            const overlow = target.closest('body').querySelector('.overlow');
            const modalHintBlock = modalHintTotal.querySelector('.modalHintTotal__block');

            const modalHintRow = target.closest('body').querySelector('.modalHintRow');
            const modalHintBlockRow = modalHintRow.querySelector('.modalHintTotal__block');

            if (inputText) {
                inputValue(inputText);
            }

            // При клике на "₽" меняет ₽ на % и наоборот
            // В самом вверхнем инпуте и меняет на всех
            if (badgeBottomInputBottom) {
                const saleVal = badgeBottomInputBottom.getAttribute('value');
                badgeBottomInputBottom.setAttribute('value', '%');
                if (saleVal == '%') {
                    badgeBottomInputBottom.setAttribute('value', '₽');
                }

                modalHintRow.classList.add('show');
                overlow.classList.add('overlow--active');

                if (saleVal === '%') {
                    const modalHintContent = `
                        <div class="modalHintTotal__icons d-justify-items-center">
                             <span>
                                <svg width="32" height="32" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"><g id="bold_copy_47_"><path d="M245,0C109.683,0,0,109.684,0,245s109.683,245,245,245s245-109.684,245-245S380.316,0,245,0z M245,459.375 c-118.213,0-214.375-96.163-214.375-214.375S126.787,30.625,245,30.625c118.212,0,214.375,96.163,214.375,214.375 S363.212,459.375,245,459.375z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M221.557,179.861c0-22.05-4.808-38.312-14.424-48.847c-9.647-10.52-22.969-15.772-40.012-15.772 c-16.461,0-29.522,5.283-39.139,15.864c-9.647,10.581-14.455,26.827-14.455,48.755c0,22.05,4.808,38.312,14.455,48.831 c9.616,10.52,22.969,15.772,39.981,15.772c16.476,0,29.522-5.283,39.154-15.848C216.748,218.035,221.557,201.788,221.557,179.861z M178.804,211.573c-2.787,4.012-6.676,6.018-11.699,6.018c-4.885,0-8.728-2.006-11.5-6.018c-3.675-5.451-5.512-16.124-5.512-32.034 s1.838-26.613,5.512-32.064c2.787-4.012,6.63-6.018,11.5-6.018c5.023,0,8.912,2.052,11.699,6.171 c3.553,5.344,5.359,15.986,5.359,31.896C184.163,195.433,182.372,206.137,178.804,211.573z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><polygon points="298.533,115.242 168.131,373.533 202.86,373.533 332.235,115.242 " fill="#000000" style="fill: rgb(50, 179, 72);"></polygon><path d="M332.572,244.633c-16.691,0-29.844,5.298-39.46,15.864c-9.647,10.581-14.455,26.827-14.455,48.755 c0,22.05,4.808,38.358,14.455,48.923c9.616,10.581,22.938,15.864,39.981,15.864c16.461,0,29.522-5.283,39.139-15.864 c9.647-10.566,14.455-26.873,14.455-48.923c0-21.928-4.808-38.174-14.455-48.755C362.6,249.931,349.385,244.633,332.572,244.633z M343.766,341.147c-2.664,4.012-6.508,6.018-11.53,6.018c-4.885,0-8.728-2.067-11.5-6.171c-3.675-5.344-5.512-15.986-5.512-31.896 c0-15.91,1.837-26.598,5.512-32.064c2.664-4.012,6.508-6.018,11.5-6.018c5.023,0,8.912,2.006,11.699,6.018 c3.552,5.467,5.344,16.155,5.344,32.064C349.278,325.008,347.441,335.681,343.766,341.147z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></svg>
                            </span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                </svg>
                            </span>
                            <span>
                                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512.009 512.009" style="enable-background:new 0 0 512.009 512.009;" xml:space="preserve"><g><g><g><path d="M256.004,0.004C114.832,0.004,0,114.845,0,256.009s114.832,255.996,256.004,255.996 c141.164,0,255.996-114.832,256.004-255.996C512.009,114.845,397.177,0.004,256.004,0.004z M256.004,479.247 c-123.094,0-223.238-100.144-223.238-223.238S132.91,32.77,256.004,32.77s223.238,100.144,223.238,223.238 S379.099,479.247,256.004,479.247z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M276.505,127.261h-70.218c-9.052,0-16.383,7.331-16.383,16.383v104.218H169.35c-9.052,0-16.383,7.331-16.383,16.383 c0,9.052,7.331,16.392,16.383,16.392h20.554v22.578H169.35c-9.052,0-16.383,7.34-16.383,16.392s7.331,16.392,16.383,16.392 h20.554v32.376c0,9.052,7.331,16.392,16.383,16.392s16.383-7.348,16.383-16.392v-32.375h89.823 c9.044,0,16.383-7.339,16.383-16.392s-7.331-16.392-16.383-16.392H222.67v-22.578h53.844c27.37,0,50.454-7.694,66.766-22.249 c15.203-13.561,23.572-32.171,23.572-52.397C366.852,167.828,335.177,127.261,276.505,127.261z M321.448,233.937 c-10.206,9.115-25.746,13.925-44.942,13.925H222.67v-87.843h53.835c37.789,0,57.571,23.119,57.571,45.963 C334.077,216.738,329.595,226.669,321.448,233.937z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></g></g></svg>
                            </span>
                        </div>
                        <h5 class="form__title section-title">Внимание!</h5>
                        <div class="modalHintTotal__content">
                            <p class="orderregistration__item-field-text modalHintTotal-text text1">Вы сменили скидку на одном товаре с процента на рубли</p>
                        </div>
                    `
                    modalHintBlockRow.innerHTML = modalHintContent;
                } else if (saleVal === '₽') {
                    const modalHintContent = `
                        <div class="modalHintTotal__icons d-justify-items-center">
                             <span>
                                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512.009 512.009" style="enable-background:new 0 0 512.009 512.009;" xml:space="preserve"><g><g><g><path d="M256.004,0.004C114.832,0.004,0,114.845,0,256.009s114.832,255.996,256.004,255.996 c141.164,0,255.996-114.832,256.004-255.996C512.009,114.845,397.177,0.004,256.004,0.004z M256.004,479.247 c-123.094,0-223.238-100.144-223.238-223.238S132.91,32.77,256.004,32.77s223.238,100.144,223.238,223.238 S379.099,479.247,256.004,479.247z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M276.505,127.261h-70.218c-9.052,0-16.383,7.331-16.383,16.383v104.218H169.35c-9.052,0-16.383,7.331-16.383,16.383 c0,9.052,7.331,16.392,16.383,16.392h20.554v22.578H169.35c-9.052,0-16.383,7.34-16.383,16.392s7.331,16.392,16.383,16.392 h20.554v32.376c0,9.052,7.331,16.392,16.383,16.392s16.383-7.348,16.383-16.392v-32.375h89.823 c9.044,0,16.383-7.339,16.383-16.392s-7.331-16.392-16.383-16.392H222.67v-22.578h53.844c27.37,0,50.454-7.694,66.766-22.249 c15.203-13.561,23.572-32.171,23.572-52.397C366.852,167.828,335.177,127.261,276.505,127.261z M321.448,233.937 c-10.206,9.115-25.746,13.925-44.942,13.925H222.67v-87.843h53.835c37.789,0,57.571,23.119,57.571,45.963 C334.077,216.738,329.595,226.669,321.448,233.937z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></g></g></svg>
                            </span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                </svg>
                            </span>
                            <span>
                                <svg width="32" height="32" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"><g id="bold_copy_47_"><path d="M245,0C109.683,0,0,109.684,0,245s109.683,245,245,245s245-109.684,245-245S380.316,0,245,0z M245,459.375 c-118.213,0-214.375-96.163-214.375-214.375S126.787,30.625,245,30.625c118.212,0,214.375,96.163,214.375,214.375 S363.212,459.375,245,459.375z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M221.557,179.861c0-22.05-4.808-38.312-14.424-48.847c-9.647-10.52-22.969-15.772-40.012-15.772 c-16.461,0-29.522,5.283-39.139,15.864c-9.647,10.581-14.455,26.827-14.455,48.755c0,22.05,4.808,38.312,14.455,48.831 c9.616,10.52,22.969,15.772,39.981,15.772c16.476,0,29.522-5.283,39.154-15.848C216.748,218.035,221.557,201.788,221.557,179.861z M178.804,211.573c-2.787,4.012-6.676,6.018-11.699,6.018c-4.885,0-8.728-2.006-11.5-6.018c-3.675-5.451-5.512-16.124-5.512-32.034 s1.838-26.613,5.512-32.064c2.787-4.012,6.63-6.018,11.5-6.018c5.023,0,8.912,2.052,11.699,6.171 c3.553,5.344,5.359,15.986,5.359,31.896C184.163,195.433,182.372,206.137,178.804,211.573z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><polygon points="298.533,115.242 168.131,373.533 202.86,373.533 332.235,115.242 " fill="#000000" style="fill: rgb(50, 179, 72);"></polygon><path d="M332.572,244.633c-16.691,0-29.844,5.298-39.46,15.864c-9.647,10.581-14.455,26.827-14.455,48.755 c0,22.05,4.808,38.358,14.455,48.923c9.616,10.581,22.938,15.864,39.981,15.864c16.461,0,29.522-5.283,39.139-15.864 c9.647-10.566,14.455-26.873,14.455-48.923c0-21.928-4.808-38.174-14.455-48.755C362.6,249.931,349.385,244.633,332.572,244.633z M343.766,341.147c-2.664,4.012-6.508,6.018-11.53,6.018c-4.885,0-8.728-2.067-11.5-6.171c-3.675-5.344-5.512-15.986-5.512-31.896 c0-15.91,1.837-26.598,5.512-32.064c2.664-4.012,6.508-6.018,11.5-6.018c5.023,0,8.912,2.006,11.699,6.018 c3.552,5.467,5.344,16.155,5.344,32.064C349.278,325.008,347.441,335.681,343.766,341.147z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></svg>
                            </span>
                        </div>
                        <h5 class="form__title section-title">Внимание!</h5>
                        <div class="modalHintTotal__content">
                            <p class="orderregistration__item-field-text modalHintTotal-text text1">Вы сменили скидку на одном товаре с рубля на процент</p>
                            <p class="orderregistration__item-field-text modalHintTotal-text text2">Скидка не может быть 100%</p>
                        </div>
                    `
                    modalHintBlockRow.innerHTML = modalHintContent;
                }

            }

            // При клике на "₽" меняет ₽ на % и наоборот
            // На каждом инпуте в нижних инпутах
            if (badgeBottomInputTop) {
                modalHintTotal.classList.add('show');
                overlow.classList.add('overlow--active');

                // const badgeBottomInputBottom = addproductsForm.querySelectorAll('.addproducts__sale-item-badge');
                const productBadge = target.closest('.addproducts__form').querySelectorAll('.saleName');
                if (badgeBottomInputTop.value == '%') {
                    badgeBottomInputTop.setAttribute('value', '₽');
                    headerTextSale.textContent = 'Скидка ₽';
                    updateCurrentSign('₽');

                    const modalHintContent = `
                        <div class="modalHintTotal__icons d-justify-items-center">
                            <span>
                                <svg width="32" height="32" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"><g id="bold_copy_47_"><path d="M245,0C109.683,0,0,109.684,0,245s109.683,245,245,245s245-109.684,245-245S380.316,0,245,0z M245,459.375 c-118.213,0-214.375-96.163-214.375-214.375S126.787,30.625,245,30.625c118.212,0,214.375,96.163,214.375,214.375 S363.212,459.375,245,459.375z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M221.557,179.861c0-22.05-4.808-38.312-14.424-48.847c-9.647-10.52-22.969-15.772-40.012-15.772 c-16.461,0-29.522,5.283-39.139,15.864c-9.647,10.581-14.455,26.827-14.455,48.755c0,22.05,4.808,38.312,14.455,48.831 c9.616,10.52,22.969,15.772,39.981,15.772c16.476,0,29.522-5.283,39.154-15.848C216.748,218.035,221.557,201.788,221.557,179.861z M178.804,211.573c-2.787,4.012-6.676,6.018-11.699,6.018c-4.885,0-8.728-2.006-11.5-6.018c-3.675-5.451-5.512-16.124-5.512-32.034 s1.838-26.613,5.512-32.064c2.787-4.012,6.63-6.018,11.5-6.018c5.023,0,8.912,2.052,11.699,6.171 c3.553,5.344,5.359,15.986,5.359,31.896C184.163,195.433,182.372,206.137,178.804,211.573z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><polygon points="298.533,115.242 168.131,373.533 202.86,373.533 332.235,115.242 " fill="#000000" style="fill: rgb(50, 179, 72);"></polygon><path d="M332.572,244.633c-16.691,0-29.844,5.298-39.46,15.864c-9.647,10.581-14.455,26.827-14.455,48.755 c0,22.05,4.808,38.358,14.455,48.923c9.616,10.581,22.938,15.864,39.981,15.864c16.461,0,29.522-5.283,39.139-15.864 c9.647-10.566,14.455-26.873,14.455-48.923c0-21.928-4.808-38.174-14.455-48.755C362.6,249.931,349.385,244.633,332.572,244.633z M343.766,341.147c-2.664,4.012-6.508,6.018-11.53,6.018c-4.885,0-8.728-2.067-11.5-6.171c-3.675-5.344-5.512-15.986-5.512-31.896 c0-15.91,1.837-26.598,5.512-32.064c2.664-4.012,6.508-6.018,11.5-6.018c5.023,0,8.912,2.006,11.699,6.018 c3.552,5.467,5.344,16.155,5.344,32.064C349.278,325.008,347.441,335.681,343.766,341.147z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></svg>
                            </span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                </svg>
                            </span>
                            <span>
                                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512.009 512.009" style="enable-background:new 0 0 512.009 512.009;" xml:space="preserve"><g><g><g><path d="M256.004,0.004C114.832,0.004,0,114.845,0,256.009s114.832,255.996,256.004,255.996 c141.164,0,255.996-114.832,256.004-255.996C512.009,114.845,397.177,0.004,256.004,0.004z M256.004,479.247 c-123.094,0-223.238-100.144-223.238-223.238S132.91,32.77,256.004,32.77s223.238,100.144,223.238,223.238 S379.099,479.247,256.004,479.247z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M276.505,127.261h-70.218c-9.052,0-16.383,7.331-16.383,16.383v104.218H169.35c-9.052,0-16.383,7.331-16.383,16.383 c0,9.052,7.331,16.392,16.383,16.392h20.554v22.578H169.35c-9.052,0-16.383,7.34-16.383,16.392s7.331,16.392,16.383,16.392 h20.554v32.376c0,9.052,7.331,16.392,16.383,16.392s16.383-7.348,16.383-16.392v-32.375h89.823 c9.044,0,16.383-7.339,16.383-16.392s-7.331-16.392-16.383-16.392H222.67v-22.578h53.844c27.37,0,50.454-7.694,66.766-22.249 c15.203-13.561,23.572-32.171,23.572-52.397C366.852,167.828,335.177,127.261,276.505,127.261z M321.448,233.937 c-10.206,9.115-25.746,13.925-44.942,13.925H222.67v-87.843h53.835c37.789,0,57.571,23.119,57.571,45.963 C334.077,216.738,329.595,226.669,321.448,233.937z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></g></g></svg>
                            </span>
                        </div>
                        <h5 class="form__title section-title">Внимание!</h5>
                        <div class="modalHintTotal__content">
                            <p class="orderregistration__item-field-text modalHintTotal-text text1">Вы сменили общую скидку на все колонки с процента на рубли.</p>
                            <p class="orderregistration__item-field-text modalHintTotal-text text2">Введите сумму в рублях.</p>
                        </div>
                    `
                    modalHintBlock.innerHTML = modalHintContent;
                    // console.log(target.closest('body').querySelector('.modalHintTotal').querySelector('.text1'))
                } else if (badgeBottomInputTop.value == '₽') {
                    badgeBottomInputTop.setAttribute('value', '%');
                    headerTextSale.textContent = 'Скидка %';
                    updateCurrentSign('%');

                    const modalHintContent = `
                        <div class="modalHintTotal__icons d-justify-items-center">
                            <span>
                                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512.009 512.009" style="enable-background:new 0 0 512.009 512.009;" xml:space="preserve"><g><g><g><path d="M256.004,0.004C114.832,0.004,0,114.845,0,256.009s114.832,255.996,256.004,255.996 c141.164,0,255.996-114.832,256.004-255.996C512.009,114.845,397.177,0.004,256.004,0.004z M256.004,479.247 c-123.094,0-223.238-100.144-223.238-223.238S132.91,32.77,256.004,32.77s223.238,100.144,223.238,223.238 S379.099,479.247,256.004,479.247z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M276.505,127.261h-70.218c-9.052,0-16.383,7.331-16.383,16.383v104.218H169.35c-9.052,0-16.383,7.331-16.383,16.383 c0,9.052,7.331,16.392,16.383,16.392h20.554v22.578H169.35c-9.052,0-16.383,7.34-16.383,16.392s7.331,16.392,16.383,16.392 h20.554v32.376c0,9.052,7.331,16.392,16.383,16.392s16.383-7.348,16.383-16.392v-32.375h89.823 c9.044,0,16.383-7.339,16.383-16.392s-7.331-16.392-16.383-16.392H222.67v-22.578h53.844c27.37,0,50.454-7.694,66.766-22.249 c15.203-13.561,23.572-32.171,23.572-52.397C366.852,167.828,335.177,127.261,276.505,127.261z M321.448,233.937 c-10.206,9.115-25.746,13.925-44.942,13.925H222.67v-87.843h53.835c37.789,0,57.571,23.119,57.571,45.963 C334.077,216.738,329.595,226.669,321.448,233.937z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></g></g></svg>
                            </span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                </svg>
                            </span>
                            <span>
                                <svg width="32" height="32" x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"><g id="bold_copy_47_"><path d="M245,0C109.683,0,0,109.684,0,245s109.683,245,245,245s245-109.684,245-245S380.316,0,245,0z M245,459.375 c-118.213,0-214.375-96.163-214.375-214.375S126.787,30.625,245,30.625c118.212,0,214.375,96.163,214.375,214.375 S363.212,459.375,245,459.375z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><path d="M221.557,179.861c0-22.05-4.808-38.312-14.424-48.847c-9.647-10.52-22.969-15.772-40.012-15.772 c-16.461,0-29.522,5.283-39.139,15.864c-9.647,10.581-14.455,26.827-14.455,48.755c0,22.05,4.808,38.312,14.455,48.831 c9.616,10.52,22.969,15.772,39.981,15.772c16.476,0,29.522-5.283,39.154-15.848C216.748,218.035,221.557,201.788,221.557,179.861z M178.804,211.573c-2.787,4.012-6.676,6.018-11.699,6.018c-4.885,0-8.728-2.006-11.5-6.018c-3.675-5.451-5.512-16.124-5.512-32.034 s1.838-26.613,5.512-32.064c2.787-4.012,6.63-6.018,11.5-6.018c5.023,0,8.912,2.052,11.699,6.171 c3.553,5.344,5.359,15.986,5.359,31.896C184.163,195.433,182.372,206.137,178.804,211.573z" fill="#000000" style="fill: rgb(50, 179, 72);"></path><polygon points="298.533,115.242 168.131,373.533 202.86,373.533 332.235,115.242 " fill="#000000" style="fill: rgb(50, 179, 72);"></polygon><path d="M332.572,244.633c-16.691,0-29.844,5.298-39.46,15.864c-9.647,10.581-14.455,26.827-14.455,48.755 c0,22.05,4.808,38.358,14.455,48.923c9.616,10.581,22.938,15.864,39.981,15.864c16.461,0,29.522-5.283,39.139-15.864 c9.647-10.566,14.455-26.873,14.455-48.923c0-21.928-4.808-38.174-14.455-48.755C362.6,249.931,349.385,244.633,332.572,244.633z M343.766,341.147c-2.664,4.012-6.508,6.018-11.53,6.018c-4.885,0-8.728-2.067-11.5-6.171c-3.675-5.344-5.512-15.986-5.512-31.896 c0-15.91,1.837-26.598,5.512-32.064c2.664-4.012,6.508-6.018,11.5-6.018c5.023,0,8.912,2.006,11.699,6.018 c3.552,5.467,5.344,16.155,5.344,32.064C349.278,325.008,347.441,335.681,343.766,341.147z" fill="#000000" style="fill: rgb(50, 179, 72);"></path></g></svg>
                            </span>
                        </div>
                        <h5 class="form__title section-title">Внимание!</h5>
                        <div class="modalHintTotal__content">
                            <p class="orderregistration__item-field-text modalHintTotal-text text1">Вы сменили общую скидку на все колонки с рубля на проценты.</p>
                            <p class="orderregistration__item-field-text modalHintTotal-text text2">Введите процент скидки (<span><b>скидка не может быть больше 100%</b></span>)</p>
                        </div>
                    `
                    modalHintBlock.innerHTML = modalHintContent;
                }

                productBadge.forEach(el => {
                    el.setAttribute('value', `${badgeBottomInputTop.getAttribute('value')}`)
                })
            }

            // Добавляет карточки на страницу
            if (btnAdd) {
                createCard();
                numberingOrder(addproductsBodyList);
            }

            // Удаляет карточки со страницы
            if (btnDelete) {
                row.remove();
                numberingOrder(addproductsBodyList);
            }

            // Работа с инпут file (показывает количество загруженных картинок)
            inputFile ? addproductsInputsFile(inputFile) : '';

            // Удаляет класс у select open
            selects.forEach(element => element.classList.remove('open'));

            // Открытия/Закрытия select
            selesctWrap ? switchSelect(selects, target) : '';

            // Добавляет из списка select текст в инпут
            if (selesctContentListText) {
                const selectInput = selesctWrap.querySelector('.addproducts__select-input input');
                addTextInput(selesctContentListText, selectInput, selects);
            }

            clickProd();

        });
    }


    // При вводе в самый вверхний инпут, записывает во все остальные созданные инпуты
    function inputValue(inputText) {
        inputText.addEventListener('input', (e) => {
            const inputSale= addproductsForm.querySelectorAll('.salePrice');
            const inputValue= document.querySelectorAll('.addproducts__body-bottom-row');
            const currentSign = document.querySelector('.addproducts__sale-item-badge-top').value;

            for (let i = 0; i < inputValue.length; i++) {
                const value = {
                    quantity: inputValue[i].querySelector('.quantity').value,
                    price: inputValue[i].querySelector('.price').value,
                    salePrice: inputValue[i].querySelector('.salePrice').value,
                    total: inputValue[i].querySelector('.total'),
                }

                if (currentSign === '%' && parseInt(inputText.value) >= 100) {
                    inputText.value = 100;
                }
                if (value.quantity !== '' && value.price !== '0') {
                    inputSale[i].value = inputText.value;
                }
                if (value.quantity === '' && value.price === '0') {
                    value.quantity = 0;
                    value.price = 0;
                    value.salePrice = 0;
                } else if (inputText.value === '') {
                    value.salePrice = 0;
                    value.total.value = 0;
                } else {
                    calculateDiscountedPrice(
                        currentSign,
                        value.quantity,
                        value.price,
                        inputText.value,
                        value.total
                    );
                }
            }
        })
    }

    function calculate(wrapCalc = document.querySelector('.addproducts__body-bottom')) {
        if (!wrapCalc) return;
        wrapCalc.addEventListener('input', (e) => {
            debounceTimeout = setTimeout(() => {
                clearTimeout(debounceTimeout);
                const itemRow = wrapCalc.querySelectorAll('.addproducts__body-bottom-row');

                for (let i = 0; i < itemRow.length; i++) {
                    const inputEl = {
                        quantity: itemRow[i].querySelector('.quantity'),
                        price: itemRow[i].querySelector('.price'),
                        salePrice: itemRow[i].querySelector('.salePrice'),
                        saleName: itemRow[i].querySelector('.saleName').value,
                        total: itemRow[i].querySelector('.total'),
                    };

                    inputEl.quantity.value = inputEl.quantity.value.replace(/[^0-9]/g, '');
                    inputEl.price.value = inputEl.price.value.replace(/[^0-9]/g, '');
                    inputEl.salePrice.value = inputEl.salePrice.value.replace(/[^0-9]/g, '');

                    if (inputEl.salePrice.value === '') {
                        inputEl.total.value = 0;
                    }

                    if (inputEl.saleName === '%' && inputEl.salePrice.value >= 100) {
                        inputEl.salePrice.value = 100;
                    }

                    const quantity = inputEl.quantity.value || 0;
                    const price = inputEl.price.value || 0;
                    const salePrice = inputEl.salePrice.value || 0;

                    calculateDiscountedPrice(
                        itemRow[i].querySelector('.saleName').value,
                        quantity,
                        price,
                        salePrice,
                        inputEl.total
                    );
                }
            }, 300);

        });
    }
    calculate(document.querySelector('.addproducts__body-bottom'));

    function clickProd() {
        const rows = document.querySelectorAll('.addproducts__body-bottom-row');
        rows.forEach(row => {
            const saleTypeElement = row.querySelector('.saleName');
            saleTypeElement.addEventListener('click', event => {
                const currentSign = event.target.value === '%' ? '₽' : '%'; // Определяем текущий знак для этого ряда

                const inputs = {
                    quantity: row.querySelector('.quantity').value,
                    price: row.querySelector('.price').value,
                    salePrice: row.querySelector('.salePrice').value,
                    total: row.querySelector('.total')
                };

                if (currentSign === '%') {
                    row.querySelector('.salePrice').value = parseInt(inputs.salePrice) < 100 ? inputs.salePrice : 100;
                }

                if (inputs.quantity === '' && inputs.price === '0' && inputs.salePrice === '') {
                    inputs.quantity = 0;
                    inputs.price = 0;
                    inputs.salePrice = 0;
                } else {
                    if (inputs.salePrice !== '') {
                        calculateDiscountedPrice(
                            currentSign,
                            inputs.quantity,
                            inputs.price,
                            inputs.salePrice,
                            inputs.total
                        );
                    }
                }
            });
        });
    }
    clickProd();

    function clickProdTotal() {
        const totalKolonka = document.querySelector('.addproducts__sale-item');
        if (totalKolonka) {
            totalKolonka.addEventListener('click', (e) => {
                const badge = e.target.closest('.addproducts__sale-item-badge-top');
                if (badge) {
                    const currentSign = badge.value === '%' ? '₽' : '%'; // Определяем текущий знак для этого ряда
                    const inputTotal = totalKolonka.querySelector('.addproducts__sale-item-input-top');
                    if (currentSign === '%') {

                        if (parseInt(inputTotal.value) > 100) {
                            inputTotal.value = 100;
                            const row = e.target.closest('.addproducts__form').querySelectorAll('.addproducts__body-bottom-row');
                            row.forEach(el => {

                                if (inputTotal.value === '') {
                                    el.querySelector('.total').value = 0;
                                }

                                if (el.querySelector('.salePrice').value !== '') {
                                    el.querySelector('.salePrice').value = inputTotal.value;
                                }
                                if (el.querySelector('.quantity').value === '' && el.querySelector('.price').value === '0' && el.querySelector('.salePrice').value === '') {
                                    el.querySelector('.total').value = 0;
                                } else {
                                    calculateDiscountedPrice(
                                        '%',
                                        el.querySelector('.quantity').value,
                                        el.querySelector('.price').value,
                                        inputTotal.value,
                                        el.querySelector('.total')
                                    );
                                }

                            });
                        } else {
                            const row = e.target.closest('.addproducts__form').querySelectorAll('.addproducts__body-bottom-row');
                            row.forEach(el => {
                                if (el.querySelector('.quantity').value === '' && el.querySelector('.price').value === '0' && el.querySelector('.salePrice').value === '') {
                                    el.querySelector('.total').value = 0;
                                } else {
                                    calculateDiscountedPrice(
                                        '%',
                                        el.querySelector('.quantity').value,
                                        el.querySelector('.price').value,
                                        inputTotal.value,
                                        el.querySelector('.total')
                                    );
                                }
                            });
                        }
                    } else if (currentSign === '₽') {
                        const row = e.target.closest('.addproducts__form').querySelectorAll('.addproducts__body-bottom-row');
                        row.forEach(el => {
                            if (el.querySelector('.quantity').value === '' && el.querySelector('.price').value === '0' && el.querySelector('.salePrice').value === '') {
                                el.querySelector('.total').value = 0;
                            } else {
                                calculateDiscountedPrice(
                                    '₽',
                                    el.querySelector('.quantity').value,
                                    el.querySelector('.price').value,
                                    inputTotal.value,
                                    el.querySelector('.total')
                                );
                            }
                        });
                    }
                }
            });
        }
    }
    clickProdTotal();

    // Расчет цены со скидкой
    function calculateDiscountedPrice(currentSign = '%', quantity = 0, price = 0, salePrice = 0, priceSale) {
        let total = calcProduct(parseInt(quantity), parseInt(price));
        if (currentSign === '%') { // Если выбран %, используем расчёт со скидкой в процентах
            if (salePrice !== 0) {
                let discount= total * calcPercent(parseFloat(salePrice));
                let discountedTotal= total - discount;
                priceSale.value = discountedTotal.toLocaleString();
            }

        } else if (currentSign === '₽') { // Если выбран ₽, используем расчёт со скидкой в рублях
            if (salePrice !== 0) {
                let discount= total - parseFloat(salePrice);
                priceSale.value = discount.toLocaleString();
            }
        }
    }




    function calcProduct(a, b) {
        return a * b;
    }
    function calcPercent(percentage) {
        return percentage / 100;
    }



    // Порядок нумерации карточек при добавлении/удаленни карточки
    function numberingOrder(list) {
        const numberEl = list.querySelectorAll('.addproducts__body-bottom-number');
        const inputFile = list.querySelectorAll('.file__form-input');
        const inputFileLabel = list.querySelectorAll('.file__form-file-label');

        for (let i = 0; i < numberEl.length; i++) {
            numberEl[i].textContent = i + 1;
            inputFile[i].setAttribute('id', 'input__file' + i);
            inputFileLabel[i].setAttribute('for', 'input__file' + i);
        }
    }

    // Работа с инпут file (показывает количество загруженных картинок)
    function addproductsInputsFile(input) {
        const wrapInput = input.closest('.file__form-field-wrap');
        if (wrapInput) {
            const quantityImg = wrapInput.querySelector('.file__form-count');
            wrapInput.querySelector('.file__form-input-file').addEventListener('change', ({target}) => {
                let filesLength = target.files.length;
                if (filesLength > 10) return;
                quantityImg.style.display = 'flex';
                quantityImg.textContent = filesLength;
            });
        }

    }

    // Добавляет из списка select текст в инпут
    function addTextInput(contentListText, selectInput, selects) {
        const text = contentListText.dataset.text;
        selectInput.value = text;
        selects.forEach(element => element.classList.remove('open'));
    }

    // Открытия/Закрытия select
    function switchSelect(selects, select) {
        selects.forEach(element => {
            element.classList.remove('open');
        });
        select.closest('.addproducts__select-wrap').classList.add('open');

        // Закрывает select по клику в не элемента
        document.addEventListener('click', ( {target} ) => {
            if (!target.closest('.addproducts__select-wrap')) {
                selects.forEach(el => {
                    el.classList.remove('open');
                });
            }
        });
    }

    // Очищает все поля в изначальный вид
    if (addproductsBtnReset) {
        addproductsBtnReset.addEventListener('click', (e) => {
            e.preventDefault();
            const inputReset = addproductsBodyList.querySelectorAll('.addproducts__inputReset');
            const inputTopReset = document.querySelector('.addproducts__sale-item-input-top');
            const selectInputReset = addproductsBodyList.querySelectorAll('.addproducts__selectReset');
            const inputFileReset = addproductsBodyList.querySelectorAll('.file__form-count');
            const badgeTop = document.querySelector('.addproducts__sale-item-badge-top');
            const badge = addproductsBodyList.querySelectorAll('.addproducts__sale-item-badge');

            badge.forEach(el => {
                const saleVal = el.getAttribute('value');
                if (saleVal == '₽') {
                    el.setAttribute('value', '%');
                    badgeTop.setAttribute('value', '%');
                }
            });

            inputReset.forEach(el => {
                el.value = '';
            });
            selectInputReset.forEach(el => {
                el.value = 'шт';
            });
            inputFileReset.forEach(el => {
                el.style.display = 'none'
            });

            inputTopReset.value = '';

        });

    }
    // end Страница разгрузите производство















    // begin инпут type=file
    const inputFiles = document.querySelectorAll('.js-inputfile');
    let error = '';
    inputFiles.forEach(file => {
        file.addEventListener('change', (e) => {
            const fileWrap = e.target.closest('.js-inputfile');
            const fileText = fileWrap.querySelector('.file__form-file-label > span');
            let textError = fileWrap.querySelector('.file__form-field-checktext');

            const fileLength = e.target.files.length;
            const fileSize = e.target.files;
            for (let i = 0; i < fileSize.length; i++) {
                const size = fileSize[i].size;
            }

            if (fileLength <= 10) {
                if (fileText) {
                    fileText.textContent = `Прикрепить файл (${fileLength})`;
                }
                if (textError) {
                    textError.textContent = '';
                }

            } else {
                error = 'Не больше 10 файлов';
                if (textError) {
                    textError.textContent = error;
                }

            }
        })
    });

    // function formatBytes(bytes, decimals = 2) {
    //     if (bytes === 0) {
    //         return '0';
    //     } else {
    //         let k = 1024;
    //         let dm = decimals < 0 ? 0 : decimals;
    //         let sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
    //         let i = Math.floor(Math.log(bytes) / Math.log(k));
    //         return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    //     }
    // }

    // alert(formatBytes(100000)); // 97.66 КБ
    // end инпут type=file






    // begin Страница о компании
    // Открывает модальное окно по плэй иконке
    const videoItemsIconPlay = document.querySelectorAll('.uschoose__slider-iconplay');
    videoItemsIconPlay.forEach(el => {
        el.addEventListener('click', ( {target} ) => {
            let modalVideoIframe = document.querySelector('.video-iframe');
            const dataVideoSrc = target.closest('.uschoose__slider-images').dataset.video;
            modalVideoIframe.contentWindow.location = dataVideoSrc;
        });
    });
    // Открывает модальное окно по плэй иконке



    // Scroll горизонтальный скролл видео блок
    const scrollContent = document.querySelector('.js--scrollContent');

    if (scrollContent) {
        function scrollHorizontally(e) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
            scrollContent.scrollLeft -= (delta*100); // Multiplied by 10
            e.preventDefault();
        }
        if (scrollContent.addEventListener) {
            // IE9, Chrome, Safari, Opera
            scrollContent.addEventListener("mousewheel", scrollHorizontally, false);
            // Firefox
            scrollContent.addEventListener("DOMMouseScroll", scrollHorizontally, false);
        } else {
            // IE 6/7/8
            scrollContent.attachEvent("onmousewheel", scrollHorizontally);
        }
    }
    // Scroll горизонтальный скролл видео блок



    // Бегущие цифры
    // const sectionCompanyintro = document.querySelector('.section-companyintro');
    // const achievementsItemNumbers = document.querySelectorAll('.achievements__item-text');
    // let flag = true;

    // // 7400
    // // 120 530
    // // 500
    // // 100 000
    // // 3 080

    // document.addEventListener('scroll', (e) => {
    //     let scrollY = window.pageYOffset;
    //     if (flag) {
    //         if (scrollY > sectionCompanyintro.clientHeight - 400) {
    //             flag = false;
    //             outNum(7400, achievementsItemNumbers[0], 1000, 20);
    //             outNum(120530, achievementsItemNumbers[1], 1000, 800);
    //             outNum(500, achievementsItemNumbers[2], 100, 2);
    //             outNum(100000, achievementsItemNumbers[3], 1000, 800);
    //             outNum(3080, achievementsItemNumbers[4], 1000, 10);
    //         } else {
    //             flag = true;
    //         }
    //     }

    // });

    // function outNum(num, elem, time, step) {
    //     let number = time;
    //     let step1 = step;
    //     let n = 0;
    //     let t = Math.round(number / (num / step1));
    //     let interval = setInterval(() => {
    //         n += step1;
    //         n >= num ? clearInterval(interval) : '';
    //             elem.innerHTML = n;
    //         },
    //     t);
    // };
    // Бегущие цифры
    // end Страница о компании





    // Валидация формы
    const formsValidation = document.querySelectorAll('.js-formValidation');
    function validatorForm(form) {
        let formFlag = true;
        const inputs = form.querySelectorAll('.orderregistration__item-field-input');

        // Тряска формы при пустых полях
        function animationForm() {
            form.classList.add('error');
            setInterval(() => {
                form.classList.remove('error');
            }, 600);
        }

        // Все инпуты
        inputs.forEach(input => {
            const inputFile = form.querySelector('.file__form-input');
            const blockInputFile = form.querySelector('.file__form-field');
            const textErrorFile = form.querySelector('.file__form-field-checktext');

            // Инпут файл не больше 10 файлов
            if (inputFile) {
                if (inputFile.files.length > 10) {
                    textErrorFile.style.display = 'block';
                    animationForm();
                    blockInputFile.style.border = '1px solid #f35448';
                    formFlag = false;
                }
            }

            // Проверка на пустота инпутов
            if (input.value == '') {
                const field = input.closest('.orderregistration__item-field');
                const textError = field.querySelector('.orderregistration__item--texterror');

                textError ? textError.style.display = 'block' : '';

                input.style.borderColor = '#f35448';
                animationForm();
                formFlag = false;
            } else {
                const field = input.closest('.orderregistration__item-field');
                const textError = field.querySelector('.orderregistration__item--texterror');
                textError ? textError.style.display = '' : '';
                input.style.borderColor = '';
            }
        });

        return formFlag;
    }

    // События на форму
    for (const form of formsValidation) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const target = e.target;
            const formInputs = target.querySelectorAll('.orderregistration__item-field-input');
            const formInputsFile = target.querySelector('.file__form-file-label span');
            const notifications = document.querySelector('.notifications');
            const blockInputFile = form.querySelector('.file__form-field');

            // Отпрака формы при всех заполненых полях в инпутах
            if (validatorForm(target) == true) {
                validatorForm(target);
                for (const input of formInputs) {
                    input.value = '';
                }

                formInputsFile ? formInputsFile.textContent = 'Прикрепить файл' : '';
                blockInputFile ? blockInputFile.style.border = '' : '';

                target.closest('.modal').classList.remove('show');
                notifications.classList.add('show');
                overlowShow();
            }

        });
    }
    // Валидация формы











    // ** Временное переключения карточек для показа страница товара **
    // const productsInfoCard = document.querySelectorAll('.js--products__info-card');
    // productsInfoCard.forEach((el, i) => {
    //     el.addEventListener('click', (e) => {
    //         productsInfoCard.forEach(element => {
    //             element.classList.remove('js--products__card--bg--active');
    //         });
    //         if (i < productsInfoCard.length - 1) {
    //             el.nextElementSibling.classList.add('js--products__card--bg--active');
    //         } else {
    //             productsInfoCard[0].classList.add('js--products__card--bg--active');
    //         }
    //         if (e.target === el.querySelector('.bascet__finalprice-btn')) {
    //             el.closest('body').querySelector('.modalorder').classList.add('show');
    //         }
    //     });
    // });


    // const productsSpecifications = document.querySelector('.products__specifications');
    // if (productsSpecifications) {
    //     const contentSpecifications = productsSpecifications.querySelector('.categories__list-content--specifications');
    //     let contentFlag = false;
    //     contentSpecifications.addEventListener('click', (e) => {
    //         const target = e.target;
    //         const wrapSpecifications = target.closest('.products__specifications');
    //         const choice = wrapSpecifications.querySelector('.specifications-choice');
    //         if (choice) {
    //             if (!contentFlag) {
    //                 choice.style.display = 'none';
    //                 contentFlag = true;
    //             } else {
    //                 choice.style.display = 'block';
    //                 contentFlag = false;
    //             }
    //         }
    //     });
    // }
    // // Временное переключения карточек для показа страница товара //




    // const plashka = document.querySelector('.partners__intro-wrap-plashka span');
    // if (plashka) {
    //     plashka.addEventListener('click', () => {
    //         console.log();
    //         // plashka.style.backgroundImage = `
    //         // url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23B9BEC2FF' stroke-width='1' stroke-dasharray='7%2c 9' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e")
    //         // `
    //     });
    // }


// begin menuburger
    const menuburger = document.getElementById('menuburger');
    if (menuburger) {

        overlow.addEventListener('click', (e) => {
            menuburger.classList.remove('menuburger--active');
            if (sortCategoriesModalMobile && filterCategoriesModalMobile) {
                sortCategoriesModalMobile.classList.remove('sort--show');
                filterCategoriesModalMobile.classList.remove('filter--show');
            }
            overlow.classList.remove('overlow--active');
            body.classList.remove('hidden');
            body.style.paddingRight = '';
            menuCatalogClose();
            overlowHide();
        });

        const menuItesElem = menuburger.querySelectorAll('.menuburger__list-link');
        const menuburgerDropbody = menuburger.querySelectorAll('.menuburger__drop-body');
        const menuburgerDropLink = menuburger.querySelectorAll('.menuburger__drop-link');
        const menuburgerDropDropContent = document.querySelectorAll('.menuburger__dropdrop-content');
        const menuburgerClose = document.getElementById('menuburgerClose');
        const headerBurgerCatalogBtn = document.querySelectorAll('.header__intro-burger');
        const menuburgerMain = document.querySelector('.menuburger__main').offsetWidth + 15;
        const menuburgerDrop = document.querySelector('.menuburger__drop').offsetWidth;
        const menuburgerDropDrop = document.querySelector('.menuburger__dropdrop').offsetWidth;
        const menuTwo = menuburgerMain + menuburgerDrop;
        const menuThree = menuburgerMain + menuburgerDrop + menuburgerDropDrop;

        headerBurgerCatalogBtn.forEach(element => {
            element.addEventListener('click', () => {
                menuburger.classList.add('menuburger--active');
                overlow.classList.add('overlow--active');
                menuburgerClose.style.left = `${menuburgerMain}px`;
                body.classList.add('hidden');
                overlowShow();
            });
        });

        for (const dropLink of menuburgerDropLink) {
            dropLink.addEventListener('mouseover', () => {
                for (const dropLink of menuburgerDropLink) {
                    dropLink.classList.remove('menuburger__drop-link-active');
                }
                dropLink.classList.add('menuburger__drop-link-active');
            });
        }

        menuItesElem.forEach((menuItem, i) => {
            menuItem.setAttribute('data-menu-item', i + 1);
            menuItem.addEventListener('mouseover', () => {
                const dataMenuItem = +menuItem.dataset.menuItem;

                menuItesElem.forEach(el => el.classList.remove('menuburger__list-link-background-active'));

                menuItem.classList.add('menuburger__list-link-background-active');
                menuburgerClose.style.left = `${menuTwo}px`;

                const menuburgerDropdropBody = document.querySelectorAll('.menuburger__dropdrop-body');
                menuburgerDropdropBody.forEach(element => {
                    element.closest('.menuburger__dropdrop').style.backgroundColor = '';
                    element.closest('.menuburger__dropdrop').style.opacity = '';
                    element.closest('.menuburger__dropdrop').style.visibility = '';
                    element.classList.remove('menuburger__dropdrop-body-active');
                });

                if (menuItem.classList.contains('menuburger__list-link-background-active')) {
                    for (let i = 0; i < menuburgerDropbody.length; i++) {
                        menuburgerDropbody[i].setAttribute('data-menu-section', i + 1);
                    }

                    for (let i = 0; i < menuburgerDropDropContent.length; i++) {
                        menuburgerDropDropContent[i].setAttribute('data-menu-content', i + 1);
                    }
                    menuDropBody(dataMenuItem);
                }

            });
        });

        function menuDropBody(dataMenuItem) {
            for (let i = 0; i < menuburgerDropbody.length; i++) {
                const element = menuburgerDropbody[i];
                const dataMenuSection = +element.dataset.menuSection;
                element.classList.remove('menuburger__drop-body-active');

                if (dataMenuSection === dataMenuItem) {
                    element.classList.add('menuburger__drop-body-active');
                    element.closest('.menuburger__drop').style.cssText = `
                background-color: #fff;
                opacity: 1;
                visibility: visible;
                `;

                    let arrayDropBodyWrap = Array.from(element.querySelector('.menuburger__drop-wrap').children);
                    arrayDropBodyWrap.forEach((elBodySection, i) => {
                        elBodySection.setAttribute('data-section-link', i + 1);
                    });

                } else {
                    let arrayDropBodyWrap = Array.from(element.querySelector('.menuburger__drop-wrap').children);
                    arrayDropBodyWrap.forEach((elBodySection) => {
                        elBodySection.removeAttribute('data-section-link');
                    });
                }

            }
        }

        function menuDropDropLink() {
            menuburgerDropLink.forEach(el => {
                el.addEventListener('mouseover', () => {
                    const dataDropMenuSection = el.closest('.menuburger__drop-body');
                    const dataMenuSection = +dataDropMenuSection.dataset.menuSection;

                    menuburgerDropDropContent.forEach(element => {
                        const dataMenuContent = +element.dataset.menuContent;
                        dataMenuSection === dataMenuContent ? element.classList.add('active') : element.classList.remove('active');

                        if (element.classList.contains('active')) {
                            const dropdropBody = element.querySelectorAll('.menuburger__dropdrop-body');
                            dropdropBody.forEach((elLink, i) => {
                                elLink.setAttribute('data-menu-link', i + 1);
                                const dataMenuLink = +elLink.dataset.menuLink;
                                const dataSectionLink = +el.dataset.sectionLink;

                                if (dataMenuLink === dataSectionLink) {
                                    elLink.classList.add('menuburger__dropdrop-body-active');
                                    menuburgerClose.style.left = `${menuThree}px`;

                                    elLink.closest('.menuburger__dropdrop').style.cssText = `
                        background-color: #fff;
                        opacity: 1;
                        visibility: visible;
                        `;

                                } else {
                                    elLink.classList.remove('menuburger__dropdrop-body-active');
                                }

                            });
                        } else {
                            const dropdropBody = element.querySelectorAll('.menuburger__dropdrop-body');
                            dropdropBody.forEach((elLink) => {
                                elLink.removeAttribute('data-menu-link');
                                elLink.classList.remove('menuburger__dropdrop-body-active');
                            });
                        }

                    });

                })
            });
        }

        function menuCatalogClose() {
            menuburger.classList.remove('menuburger--active');
            overlow.classList.remove('overlow--active');
            body.classList.remove('hidden');
            const menuburgerDropBody = document.querySelectorAll('.menuburger__drop-body');
            const menuburgerDropDropBody = document.querySelectorAll('.menuburger__dropdrop-body');

            for (const menuDropBody of menuburgerDropBody) {
                menuDropBody.classList.remove('menuburger__drop-body-active');
                menuDropBody.closest('.menuburger__drop').style.backgroundColor = '';
                menuDropBody.closest('.menuburger__drop').style.opacity = '';
                menuDropBody.closest('.menuburger__drop').style.visibility = '';
            }

            for (const menuDropDropBody of menuburgerDropDropBody) {
                menuDropDropBody.classList.remove('menuburger__dropdrop-body-active');
                menuDropDropBody.closest('.menuburger__dropdrop').style.backgroundColor = '';
                menuDropDropBody.closest('.menuburger__dropdrop').style.opacity = '';
                menuDropDropBody.closest('.menuburger__dropdrop').style.visibility = '';
            }

            menuburgerClose.style.left = '';
            overlowHide();
        }

        menuburgerClose.addEventListener('click', menuCatalogClose);

        menuDropDropLink();
    }
    // end menuburger




    // Header click
    const headerBlockcallWrap = document.querySelector('.header__blockcall-wrap');
    const headerBlockcallSlider = document.querySelector('.header__blockcall-slider');
    const headerBlockcallMobileEmail = document.querySelector('.header__blockcall-mobile-email');

    const headerBlockcallSliderWrap = document.querySelector('.header__blockcall-slider-wrap');

    if (headerBlockcallSliderWrap) {
        const headerBlockcallSliderImg = headerBlockcallSliderWrap.querySelectorAll('.header__blockcall-slider-item');
        const imgWidth = headerBlockcallSliderImg[0].getBoundingClientRect().width;
        let countSlider = 0;
        let timeSlider;

        function funTimeSlider() {
            timeSlider = setInterval(() => {
                countSlider++;

                if (countSlider > headerBlockcallSliderImg.length - 1) {
                    countSlider = 0
                }
                headerBlockcallSliderWrap.style.left = `-${imgWidth * countSlider}px`;
            }, 5500);
        }

        funTimeSlider();

        headerBlockcallSlider.addEventListener('mouseover', () => {
            clearInterval(timeSlider);
            // headerBlockcallWrap.classList.add('show-phone');
            headerBlockcallWrap.classList.remove('show-email');
        });

        headerBlockcallSlider.addEventListener('mouseout', () => {
            funTimeSlider();
        });

        headerBlockcallWrap.addEventListener('click', (e) => {
            const phone = e.target.closest('.header__blockcall-mobile-phone');
            const email = e.target.closest('.header__blockcall-mobile-email');

            if (phone) {
                headerBlockcallWrap.classList.toggle('show-phone');
                headerBlockcallWrap.classList.remove('show-email');
            }

            if (email) {
                headerBlockcallWrap.classList.toggle('show-email');
                headerBlockcallWrap.classList.remove('show-phone');

            }
        });

        document.addEventListener('click', ( {target} ) => {
            if ((!target.closest('.header__blockcall-wrap'))) {
                headerBlockcallWrap.classList.remove('show-phone');
                headerBlockcallWrap.classList.remove('show-email');
            }
        });
    }
    // Header click



    // Анимация таймера на странице product
    const blocktimeBtn = document.querySelectorAll('.blocktime__form-btn-submit');
    const secBottomLeft = document.querySelectorAll('.numSLeft-bottom');
    const secBottomRight = document.querySelectorAll('.numSRight-bottom');
    const msesBottomLeft = document.querySelectorAll('.numMSLeft-bottom');
    const msecBottomRight = document.querySelectorAll('.numMSRight-bottom');

    blocktimeBtn.forEach(el => {
        el.addEventListener('click', (e) => {
            var valedated = true
            e.preventDefault();

            // console.log(e.id)
            var blocktime_input = document.getElementById("blocktime_input");
            const inputChecked = document.querySelector('.js-CheckedInput');
            let chekName = inputChecked.checked ? 'Да' : 'Нет';

            let checkBool1 = 0;
            if (inputChecked) {
                checkBool1 = inputChecked.checked ? 1 : 0;
            }
            
            // console.log(blocktime_input.value.length )
            if (blocktime_input.value.length == 18 && inputChecked.checked == true){

                var xmlhttp = new XMLHttpRequest();
                xmlhttp.onreadystatechange = function() {
                    if (xmlhttp.readyState == XMLHttpRequest.DONE) {
                        if (xmlhttp.status == 200) {
                            utmFunction1(null, null, blocktime_input.value, e.target.closest('form').dataset.formId, null, null, checkBool1);
                            console.log("blocktime ответ")

                            if (blocktime_input.classList.contains('blocktime_1')){
                                console.log("blue_block_time")
                                ym(17351908, 'reachGoal', 'blue_block_time');
                            }

                            if (blocktime_input.classList.contains('blocktime_2')){
                                console.log("white_block-time")
                                ym(17351908, 'reachGoal', 'white_block-time');
                            }
                        }
                        else if (xmlhttp.status == 400) {
                            //alert('error 400');
                        }
                    }
                };

                var  formname

                if (blocktime_input.classList.contains('blocktime_1')){
                    formname = "Синяя форма перезвонить 45 секунд!"
                }else {
                    formname = "Белая форма перезвонить 45 секунд!"
                }

                console.log('1234234234', formname)

                xmlhttp.open("GET", "callback?phone=" + blocktime_input.value + "&url=" + window.location.pathname + "&formname=" + formname + "&textarea=&location=" + location + "&check_name=" + chekName, true);
                xmlhttp.send();

                blocktime_input.style.border = "2px solid #0dc143";
                inputChecked.nextElementSibling.style.border = '1px solid #ddd';
                inputChecked.nextElementSibling.nextElementSibling.style.color = '#474747';


                el.textContent = 'Ожидайте';
                el.classList.add('disabled');
                el.disabled = true;
                timeFun();
            }else {
                if (inputChecked.checked) {
                    inputChecked.nextElementSibling.style.border = '1px solid #ddd';
                    inputChecked.nextElementSibling.nextElementSibling.style.color = '#474747';
                } else {
                    inputChecked.nextElementSibling.style.border = '1px solid #ff0000';
                    inputChecked.nextElementSibling.nextElementSibling.style.color = '#ff0000';
                    console.log(inputChecked.nextElementSibling.nextElementSibling)
                }
                blocktime_input.value == "" ? blocktime_input.style.border = "2px solid #ff0000" : blocktime_input.style.border = "2px solid #0dc143";
            }

        });
    });


    


    let timeInterval;
    let timeSec = 45;
    let timeMillisec = 99;

    const timeFun = () => {
        timeInterval = setInterval(() => {
            const arrayTimeSec = String(timeSec).split('');
            const arrayTimeMSec = String(timeMillisec).split('');

            timeMillisec--;

            if (timeMillisec < 10) arrayTimeMSec.unshift(0);
            if (timeSec < 10) arrayTimeSec.unshift(0);

            if (timeMillisec < 0) {
                timeMillisec = 99;
                timeSec--;
            }

            if (timeSec < 0) clearInterval(timeInterval);

            for (let i = 0; i < secBottomLeft.length; i++) {
                secBottomLeft[i].textContent = arrayTimeSec[0];
                secBottomRight[i].textContent = arrayTimeSec[1];

                msesBottomLeft[i].textContent = arrayTimeMSec[0];
                msecBottomRight[i].textContent = arrayTimeMSec[1];
            }

        }, 10);

    }
    // Анимация таймера на странице product



    // Модальное окно опрос
    const questionnaireModalSmileysInput = document.querySelectorAll('.questionnaireModal__body-input');
    if (questionnaireModalSmileysInput) {
        for (let i = 0; i < questionnaireModalSmileysInput.length; i++) {
            questionnaireModalSmileysInput[i].addEventListener('change', ( {target} ) => {
                if (target.checked) {
                    questionnaireModalSmileysInput.forEach(element => {
                        if (!element.checked) {
                            const item = element.closest('.questionnaireModal__body-item');
                            const label = item.querySelector('.questionnaireModal__body-label');
                            label.classList.add('opacity');
                            // questionnaireModalSmileyContent();
                        }
                    });
                }
                questionnaireModalSmileyContent();
            });
        }

        const questionnaireModalSmileyContent = () => {
            const notifications = document.querySelector('.notificationsSmiley');
            const questionnaireModal = document.querySelector('.questionnaireModal');
            const content = questionnaireModal.querySelector('.questionnaireModal__body-content');
            const inputs = questionnaireModal.querySelectorAll('.questionnaireModal__body-input');
            const labels = questionnaireModal.querySelectorAll('.questionnaireModal__body-label');
            const textarea = questionnaireModal.querySelector('.questionnaireModal__body-textarea');
            const btn = questionnaireModal.querySelector('.questionnaireModalBtn');

            content.classList.add('hide');

            btn.addEventListener('click', (e) => {
                e.preventDefault();

                for (let i = 0; i < inputs.length; i++) {
                    inputs[i].checked = false;
                    labels[i].classList.remove('opacity');
                }

                content.classList.remove('hide');
                textarea.value = '';

                e.target.closest('.modal').classList.remove('show');
                notifications.classList.add('show');

            });
        }
    }
    // Модальное окно опрос

    // begin страница Отзывы клиентов reviewspage tabs
    const reviewspageTabsBtn = document.querySelectorAll('.reviewspage__tabs-text');
    const reviewspageTabsContent = document.querySelectorAll('.reviewspage__tabs-content');
    const reviewspageForm = document.querySelector('.reviewspage__form-wrapper');
    const reviewsfedbackPagination = document.querySelector('.reviewsfedback__pagination');
    const reviewspageRating = document.querySelector('.reviewspage__rating');
    const ratingBtnFixed = document.querySelector('.rating__btn-fixed');
    const reviewspageBtnFixed = document.querySelector('.reviewspage__btn-fixed');
    const reviewsfedbackWrapper = document.querySelector('.reviewsfedback__wrapper');

    for (let i = 0; i < reviewspageTabsBtn.length; i++) {
        reviewspageTabsBtn[i].addEventListener('click', ( {target} ) => {
            const dataTabNum = +target.dataset.tabsReviewspage;
            for (const tabText of reviewspageTabsBtn) {
                tabText.classList.remove('active');
            }
            target.classList.add('active');
            tabsContent(dataTabNum);
        });
    }

    function tabsContent(dataTabNum) {
        reviewspageTabsContent.forEach(el => {
            const dataTabContentNum = +el.dataset.tabsReviewspageContent;

            if (dataTabContentNum === dataTabNum) {
                reviewspageTabsContent.forEach(el => el.classList.remove('show'));
                el.classList.add('show');
            }

            if (dataTabNum === 2 || dataTabNum === 3) {
                reviewspageRating.style.display = 'none';
                if (mediaMaxQueryForm.matches) {
                    ratingBtnFixed.style.display = 'none';
                    reviewspageBtnFixed.style.display = 'none';
                }
            } else {
                reviewspageRating.style.display = 'block';
                if (mediaMaxQueryForm.matches) {
                    ratingBtnFixed.style.display = 'block';
                }

            }

            if (dataTabNum === 2) {
                reviewsfedbackWrapper.style.display = 'none';
            } else {
                reviewsfedbackWrapper.style.display = 'block';
            }

            if (dataTabNum === 3) {
                reviewspageForm.style.display = 'block';
                reviewsfedbackPagination.style.display = 'block';
                if (mediaMaxQueryForm.matches) {
                    reviewspageBtnFixed.style.display = 'block'
                }
                ;

            } else {
                reviewspageForm.style.display = 'none';
                reviewsfedbackPagination.style.display = 'none';
            }

        });
    }
    // end страница Отзывы клиентов reviewspage tabs




    // begin Модальное окно поделиться +
    const btnShare = document.querySelectorAll('.vacancy-btnsShare');
    const btnModalCopy = document.querySelector('.modalShare__btn');
    const btnModalCopyVacancy = document.querySelector('.modalShare__btn-vacancy');
    const btnModalV= document.querySelector('.v-modal-btn');

    function objSocial(link) {
        const social = {
            whatsAppShare: document.querySelector('.whatsApp-share'),
            telegramShare: document.querySelector('.telegram-share'),
            vkShare: document.querySelector('.vk-share'),
            odShare: document.querySelector('.od-share'),
        };

        social.whatsAppShare.href = 'https://web.whatsapp.com/send?text=' + `${link}.href`;
        social.telegramShare.href = 'https://t.me/share/url?url=' + `${link}.href`;
        social.vkShare.href = 'https://vkontakte.ru/share.php?url=' + `${link}.href`;
        social.odShare.href = 'https://connect.ok.ru/offer?url=' + `${link}.href`;
    }

    function modalShare(target) {
        const copy = document.querySelector('.copy');
        target.closest('.modal').classList.remove('show');
        overlowHide();
        copy.classList.add('show');

        const interval = setInterval(() => {
            clearInterval(interval);
            copy.classList.remove('show');
        }, 1500);
    }

    if (btnShare) {
        btnShare.forEach(el => {
            el.addEventListener(('click'), (e) => {
                const card = e.target.closest('.vacancy__card');
                const link = card.querySelector('.share-link a');
                objSocial(link);
                btnmodalCopy(link);
            })
        })

        function btnmodalCopy(link) {
            btnModalCopy.addEventListener(('click'), (e) => {
                if (link) copyToClipboard(link);
                modalShare(e.target);
            });
        }

    }

    function btnmodalCopy1() {
        if (btnModalV) {
            btnModalV.addEventListener(('click'), (e) => {
                const link = document.location.href;

                objSocial(link);

                btnModalCopyVacancy.addEventListener('click', (e) => {
                    copyToClipboard(link.trim());
                    modalShare(e.target);
                });
            });
        }
    }
    btnmodalCopy1();
    // end Модальное окно поделиться +




    // begin video
    const videoPlay = (selector) => {
        const wrapVideo = document.querySelector(selector);
        if (wrapVideo) {
            wrapVideo.addEventListener('click', ( {target} ) => {
                const videoItem = target.closest('.vedeoPlay__item');
                if (videoItem) {
                    const videoBtn = videoItem.querySelector('.vedeoPlay__btn');
                    const video = videoItem.querySelector('video');

                    videoBtn.style.display = 'none';
                    video.setAttribute('controls', '');
                    video.play();
                }
            });
        }
    }
    videoPlay('.videoPlay');
    // end video

    // begin Подсказка для фильтров на стр категория
    const btnFilterHint = document.querySelector('.btn__hint');
    if (btnFilterHint) {
        const hintBlock = () => {
            let count = 0;
            const overlowHint = document.querySelector('.overlowHint');
            const categoriesFilterHint = document.querySelector('.categories__filter--hint');
            const categoriesFilterBlockhints = document.querySelectorAll('.categories__filter-blockhint');

            // Скрывает подсказку по нажатию на overlow
            const removeShowHint = () => {
                categoriesFilterBlockhints.forEach(el => el.style.display = '');
                overlowHint.classList.remove('active');
                categoriesFilterHint.classList.remove('show');
                count = 0;
            }

            // Показывает подсказку при клике на кнопку Как искать товар
            btnFilterHint.addEventListener('click', () => {
                categoriesFilterBlockhints.forEach(el => el.style.display = 'block');
                overlowHint.classList.add('active');
                categoriesFilterHint.classList.add('show');
            });

            // Скрывает по крестику каждую подсказку
            categoriesFilterBlockhints.forEach(el => {
                el.addEventListener('click', ( {target} ) => {
                    const closeHint = target.closest('.categories__filter-hint-close');

                    if (closeHint) {
                        const blockHint = closeHint.closest('.categories__filter-blockhint');
                        count++;
                        blockHint.style.display = 'none';
                        if (count === categoriesFilterBlockhints.length) {
                            removeShowHint();
                            count = 0;
                        }
                    }
                });
            });

            overlowHint.addEventListener('click', () => removeShowHint());
        }

        hintBlock();
    }
    // end Подсказка для фильтров на стр категория


    // Модальное окно стр. Производство ЖБИ (чертежи)
    const modal = document.querySelector('.planModal')
    const productionImagesPlan = document.querySelectorAll('.production__intro-bottom-wrap__img');

    const openModalPlan = (img) => {
        const planModalImg = document.querySelector('.planModal__img img');
        planModalImg.src = `${img}`;
        modal.classList.add('show');
        overlowShow();
    }

    if (productionImagesPlan) {
        productionImagesPlan.forEach(img => {
            img.addEventListener('click', (e) => {
                const dataImage = e.target.querySelector('img').dataset.img;
                openModalPlan(dataImage);
            });
        });
    }
    // hiddenModalPlan();
    // Модальное окно стр. Производство ЖБИ (чертежи)





    // Анимация иконки phone на кнопке
    const contactmeInfoBtnAnim = document.querySelectorAll('.animIconBtn');
    for (const animBtn of contactmeInfoBtnAnim) {
        setInterval(() => animBtn.classList.remove('anim'), 2000);
        setInterval(() => animBtn.classList.add('anim'), 15000);
    }
    // Анимация иконки phone на кнопке

    // Переключения Телефон/Почта
    const modalContactMe = document.querySelector('.modalContact');
    if (modalContactMe) {
        const textTab = modalContactMe.querySelectorAll('.modalContact__tabs-top-text');
        const inputTab = modalContactMe.querySelectorAll('.modalContact__tab');
        for (let i = 0; i < textTab.length; i++) {
            textTab[i].addEventListener('click', () => {
                for (let j = 0; j < textTab.length; j++) {
                    textTab[j].classList.remove('active');
                    inputTab[j].classList.remove('active');
                }
                textTab[i].classList.add('active');
                inputTab[i].classList.add('active');
            });
        }
    }
    // Переключения Телефон/Почта



    // begin Пагинация на стр новости рубрика

    const pagination = document.querySelector('#paginationNews');
    if (pagination) {
        const paginationList = pagination.querySelector('.pagination__list');
        const contentNews = document.querySelector('.news__item-content-list');
        const contentLinks = Array.from(document.querySelector('.news__item-content-list').children);

        const paginationBtnLeft = pagination.querySelector('.pagination__btn-icon-left');
        const paginationBtnRight = pagination.querySelector('.pagination__btn-icon-right');

        const itemsPageNews = 20;
        let currentPage = 1;
        const maxVisiblePages = 3; // Максимальное количество видимых страниц

        const totalPages = Math.ceil(contentLinks.length / itemsPageNews);

        const btnPaginationLeftShow = () => {
            paginationBtnLeft.style.cssText = `
            opacity: 1;
            visibility: visible;
        `;
        }

        const btnPaginationLeftHidden = () => {
            paginationBtnLeft.style.cssText = `
            opacity: 0;
            visibility: hidden;
        `;
        }

        const btnPaginationRightShow = () => {
            paginationBtnRight.style.cssText = `
            opacity: 1;
            visibility: visible;
        `;
        }

        const btnPaginationRightHidden = () => {
            paginationBtnRight.style.cssText = `
            opacity: 0;
            visibility: hidden;
        `;
        }

        pagination.style.display = 'none';
        if (currentPage == 1) btnPaginationLeftHidden();

        // Отображения количество новостей на странице
        const showPage = (page) => {
            const startIndex = (page - 1) * itemsPageNews;
            const endIndex = page * itemsPageNews;
            contentNews.innerHTML = '';
            contentLinks.slice(startIndex, endIndex).forEach(el => contentNews.append(el));
        }

        // Отображения количество пагинаций на странице
        const showPagination = () => {

            paginationList.innerHTML = ''; // Очищаем список перед перерисовкой

            // Первая страница всегда видима
            addPaginationItem(1, currentPage === 1);

            // Показываем ближайшие страницы вокруг текущей
            let leftEllipsisNeeded = false;
            let rightEllipsisNeeded = false;

            if (currentPage > 2 && currentPage < totalPages - 1) {
                if (currentPage > maxVisiblePages / 2) {
                    addPaginationItem('...');
                    leftEllipsisNeeded = true;
                }
            }

            const minPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
            const maxPage = Math.min(totalPages - 1, currentPage + Math.floor(maxVisiblePages / 2));

            for (let page = minPage; page <= maxPage; page++) {
                addPaginationItem(page, page === currentPage);
            }

            if (currentPage < totalPages - 1 && currentPage < totalPages - maxVisiblePages / 2) {
                if (currentPage < totalPages - maxVisiblePages / 2) {
                    addPaginationItem('...');
                    rightEllipsisNeeded = true;
                }
            }

            // Последняя страница всегда видима
            addPaginationItem(totalPages, currentPage === totalPages);

            if (leftEllipsisNeeded || rightEllipsisNeeded) {
                paginationList.querySelectorAll('.pagination__list-item').forEach((el, index) => {
                    if (el.textContent === '...' && index === 1) {
                        el.classList.add('pagination__list-item--ellipsis');
                    }
                    if (el.textContent === '...' && index === paginationList.children.length - 2) {
                        el.classList.add('pagination__list-item--ellipsis');
                    }
                });
            }
        }

        const addPaginationItem = (page, isActive) => {
            const paginationItem = document.createElement('li');
            paginationItem.classList.add('pagination__list-item', 'd-justify-items-center');
            paginationItem.textContent = typeof page === 'number' ? page.toString() : page;

            if (isActive) {
                paginationList.querySelectorAll('.pagination__list-item').forEach(item => item.classList.remove('pagination__list-item--active'));
                paginationItem.classList.add('pagination__list-item--active');
            }
            paginationList.append(paginationItem);
        }

        // Переключение страниц
        // paginationList.addEventListener('click', (e) => {
        //     const target = e.target;
        //     if (target.classList.contains('pagination__list-item') && !target.classList.contains('pagination__list-item--ellipsis')) {
        //         currentPage = parseInt(target.textContent);
        //         showPagination();
        //         showPage(currentPage);
        //     }
        //
        //     currentPage > 1 ? btnPaginationLeftShow() : btnPaginationLeftHidden();
        //     currentPage !== paginationList.querySelectorAll('.pagination__list-item').length ? btnPaginationRightShow() : btnPaginationRightHidden();
        // });

        paginationList.addEventListener('click', (e) => {
            const target = e.target;
            if (target.classList.contains('pagination__list-item') && !target.classList.contains('pagination__list-item--ellipsis')) {
                currentPage = parseInt(target.textContent);
                showPagination();
                showPage(currentPage);
            }

            // Используем totalPages для сравнения, а не количество li элементов
            currentPage > 1 ? btnPaginationLeftShow() : btnPaginationLeftHidden();
            currentPage !== totalPages ? btnPaginationRightShow() : btnPaginationRightHidden();
        });

        const paginationBtnLeftClick = () => {
            if (currentPage > 1) {
                currentPage--;
                if (currentPage == 1) {
                    btnPaginationLeftHidden();
                } else {
                    btnPaginationLeftShow();
                }
                btnPaginationRightShow();
                showPagination();
                showPage(currentPage);
            }
        }

        const paginationBtnRightClick = () => {
            const totalPages = Math.ceil(contentLinks.length / itemsPageNews);
            if (currentPage < totalPages) {
                currentPage++;
                if (currentPage === totalPages) {
                    btnPaginationRightHidden();
                } else {
                    btnPaginationRightShow();
                }
                btnPaginationLeftShow();
                showPagination();
                showPage(currentPage);
            }
        }

        if (contentLinks.length > itemsPageNews) {
            pagination.style.display = 'block';
            showPagination();
        }

        paginationBtnLeft.addEventListener('click', paginationBtnLeftClick);
        paginationBtnRight.addEventListener('click', paginationBtnRightClick);
        showPage(currentPage);
    }
    // end Пагинация на стр новости рубрика

    // В header при наведении на войти появляется меню лк
    const myprofileTop = document.querySelector('.myprofile__top');
    const navigationRegistrIcon = document.querySelector('.navigation__registr');
    const headerSidebar = document.querySelector('.header__sidebar');
    const headerSidebars = document.querySelectorAll('.header__sidebar');
    const myprofileTopLogin = document.querySelector('.myprofile__top-link-login');
    const headerLkTabLink = document.querySelectorAll('.header__lk__tab-link');

    if (myprofileTopLogin) {
        myprofileTopLogin.addEventListener('click', (e) => {
            headerSidebar.classList.add('active');
            if (headerSidebar.classList.contains('active')) {
                myprofileTop.style.display = 'none';
            }
        });
    }

    if (headerSidebar) {
        navigationRegistrIcon.addEventListener('mouseover', () => {
            headerSidebar.classList.add('active');
        });

        navigationRegistrIcon.addEventListener('mouseout', () => {
            headerSidebar.classList.remove('active');
        });
    }

    headerLkTabLink.forEach(el => {
        el.addEventListener('click', (e) => {
            headerLkTabLink.forEach(element => {
                element.closest('.header__sidebar').classList.add('active');
            });

            el.closest('.header__sidebar').classList.remove('active');
        });
    });

    window.addEventListener('click', (e) => {
        if (!e.target.closest('.navigation__registr')) {
            headerSidebars.forEach(element => {
                element.classList.remove('active');
            });
            if (myprofileTop) {
                myprofileTop.style.display = '';
            }
        }
    });
    // end ЛК


    // begin Показывает карточки при нажатии показать еще
    const btnMore = document.querySelectorAll('.btn-more');

    const showCard = (selector, count) => {
        const wrap= document.querySelector(selector);
        if (!wrap) return; // Выход, если элемент не найден

        const cards = Array.from(wrap.querySelectorAll('.card.none'));
        const colsCount = Array.from(wrap.querySelectorAll('.videoplity__col')).length;

        // Показываем кнопки "Показать ещё", если больше 6 колонок
        if (colsCount > 6) {
            const btns = document.querySelectorAll('.videoplity__btn');

            btns.forEach((btn) => {
                btn.addEventListener('click', () => {

                    // Пошагово показываем карточки по count штук
                    const newCardsToShow = cards.splice(0, count);
                    newCardsToShow.forEach(card => card.classList.remove('none')); // Или класс .show

                    // Скрываем кнопку, если показывать нечего
                    if (cards.length === 0) {
                        btn.style.display = 'none';
                    }
                });
            });
        } else {
            // Прячем кнопку, если элементов меньше или ровно 6
            const btnMore = document.querySelector('.videoplity__btn');
            if (btnMore) {
                btnMore.style.display = 'none';
            }
        }
    };

    showCard('.videoplity', 6);
    // end Показывает карточки при нажатии показать еще

    // begin Секция с видео
    const video = document.querySelector('.videoplity');

    if (video) {
        video.addEventListener('click', ( {target} ) => {
            const videoBtn = target.closest('.videoplity__play');

            if (videoBtn) {
                const videoItem = target.closest('.videoplity__col');
                const dataVideo = videoItem.dataset.video;
                const video = videoItem.querySelector('video');
                // const source = videoItem.querySelector('source');
                if (dataVideo == undefined) return;

                video.setAttribute('controls', '')
                video.play();
                videoBtn.style.display = 'none'

                video.append(createUrlVideo(dataVideo));

            }

        });
    }

    const createUrlVideo = (video) => {
        const source = document.createElement('source')
        source.setAttribute('src', `../images/pliti-perekritiya/video/${video}.mp4`);
        source.setAttribute('type', 'video/mp4');
        return source;
    }
    // end Секция с видео


    // begin стр. продукт productaccordion
    const accordionContents = document.querySelectorAll('.productaccordion__content');

    if (accordionContents) {
        accordionContents.forEach(content => {
            content.addEventListener('click', () => {
                const parentItem = content.parentElement; // Получаем родительский элемент .productaccordion__item
                const desc = parentItem.querySelector('.productaccordion__desc');
                const isOpen = parentItem.classList.contains('open');

                // Закрываем все остальные элементы
                accordionContents.forEach(otherContent => {
                    const otherParentItem = otherContent.parentElement;
                    if (otherParentItem !== parentItem && otherParentItem.classList.contains('open')) {
                        otherParentItem.classList.remove('open');
                        otherParentItem.classList.add('close'); // Добавляем класс close для плавного закрытия
                        otherParentItem.querySelector('.productaccordion__desc').style.maxHeight = '0px'; // Устанавливаем max-height в 0px для закрытых элементов
                    }
                });

                // Переключаем состояние текущего элемента
                if (!isOpen) {
                    // Открытие
                    parentItem.classList.add('open');
                    parentItem.classList.remove('close');
                    setTimeout(() => { // Задерживаем добавление класса для корректной работы анимации
                        desc.style.maxHeight = `${desc.scrollHeight}px`; // Устанавливаем точную высоту содержимого
                    }, 0);
                } else {
                    // Закрытие
                    parentItem.classList.remove('open');
                    parentItem.classList.add('close');
                    desc.style.maxHeight = '0px'; // Сбрасываем высоту
                }
            });
        });
    }

    const showMoreButton = document.querySelector('.productaccordion-footer');
    if (showMoreButton) {
        const hiddenItems = document.querySelectorAll('.productaccordion__item.hidden');
        showMoreButton.addEventListener('click', function() {
            hiddenItems.forEach(function(item) {
                item.classList.toggle('hidden');
            });

            // Меняем текст кнопки и поворачиваем стрелку
            if (this.classList.contains('show-all')) {
                this.classList.remove('show-all');
                this.querySelector('.productaccordion-footer-text').innerText = 'Показать еще';
            } else {
                this.classList.add('show-all');
                this.querySelector('.productaccordion-footer-text').innerText = 'Скрыть';
            }
        });
    }
    // end стр. продукт productaccordion

    // Begin Секция timetable
    const sectionTimetable = document.querySelector('.section-timetable');

    if (sectionTimetable) {
        const selects = sectionTimetable.querySelectorAll('.blocktime__timetable-select');

        selects.forEach(el => {
            el.addEventListener('click', (e) => {

                const text = e.target.closest('.timetable__select-item');
                const btn = el.querySelector('.timetable__select-btn span');
                const input = el.querySelector('.timetable__select-input');

                if (el.classList.contains('open')) {
                    el.classList.remove('open');
                    if (text) {
                        btn.textContent = text.textContent;
                        input.value = text.textContent;
                    }
                } else {
                    selects.forEach(el => el.classList.remove('open'));
                    el.classList.add('open');
                    if (text) {
                        btn.textContent = text.textContent;
                        input.value = text.textContent;
                    }
                }
            });
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.timetable__select-btn')) {
                selects.forEach(el => el.classList.remove('open'));
            }
        });
        // End Секция timetable
    }





    // Begin page housekit
    // Показ блоков по клику и по мышке и по наведению
    const items = document.querySelectorAll('.solution__item');

    if (items) {
        // Закрывает все элементы, кроме переданного (если нужно)
        function closeAllExcept(keepItemOpen = null) {
            items.forEach(item => {
                if (item !== keepItemOpen && item.classList.contains('show')) {
                    closeItem(item);
                }
            });
        }
        
        // Открывает элемент
        function openItem(item) {
            const desc = item.querySelector('.solution__item-desc');
            item.classList.add('show');
            desc.classList.add('active');
            
            // Сохраняем исходную высоту перед открытием
            if (!item.dataset.originalHeight) {
                item.dataset.originalHeight = item.offsetHeight + 'px';
            }
            
            // Устанавливаем новую высоту
            desc.style.height = desc.scrollHeight + 10 + 'px';
            item.style.height = item.scrollHeight + 10 + 'px';
        }
        
        // Закрывает элемент
        function closeItem(item) {
            const desc = item.querySelector('.solution__item-desc');
            item.classList.remove('show');
            desc.classList.remove('active');
            desc.style.height = '0';
            item.style.height = item.dataset.originalHeight || 'auto';
        }
        
        // Обработчики событий
        items.forEach(item => {
            // Клик — открывает элемент (другие закрываются)
            item.addEventListener('click', (e) => {
                const clickedItem = e.currentTarget;
                
                // Если уже открыт — ничего не делаем
                if (clickedItem.classList.contains('show')) return;
                
                // Закрываем все, кроме текущего
                closeAllExcept(clickedItem);
                
                // Открываем текущий
                openItem(clickedItem);
            });
        
            // Наведение мыши — открывает элемент (другие закрываются)
            item.addEventListener('mouseenter', () => {
                // Если уже открыт по клику — не реагируем на hover
                if (item.classList.contains('show')) return;
                closeAllExcept(item);
                openItem(item);
            });
        
            // Уход мыши — закрывает элемент (если не был открыт по клику)
            item.addEventListener('mouseleave', () => {
                if (!item.classList.contains('show')) {
                closeItem(item);
                }
            });
        });
    }
    // Показ блоков по клику и по мышке и по наведению




    // Анимация блоков
    // Получение всех элементов с классом .fade-in
    const animBlocks = document.querySelectorAll('.stagework__item');
    let currentIndex = 0;
    const delayBetweenItems = 300; // Задержка между появлением карточек в миллисекундах

    if (animBlocks.length > 0) {
        // Функция проверки видимости элемента
        function isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top <= (window.innerHeight * 0.75) && // Элемент в верхних 75% экрана
                rect.bottom >= (window.innerHeight * 0.25) // И в нижних 25% экрана
            );
        }

        // Функция для показа элементов с задержкой
        function showItems() {
            if (currentIndex < animBlocks.length) {
                const item = animBlocks[currentIndex];
                
                if (isElementInViewport(item)) {
                    setTimeout(() => {
                        item.classList.add('visible');
                        currentIndex++;
                        showItems(); // Рекурсивный вызов для следующего элемента
                    }, delayBetweenItems);
                }
            }
        }

        // Проверка при загрузке страницы
        showItems();

        // Проверка при скролле
        window.addEventListener('scroll', function() {
            // Если еще не все элементы показаны
            if (currentIndex < animBlocks.length) {
                showItems();
            }
        });
    }
    // Анимация блоков



    // Показать еще
    const concretehouseBtnMore = document.querySelector('.concretehouse__btn');
    if (concretehouseBtnMore) {
        concretehouseBtnMore.addEventListener('click', () =>{
            const concretehouseItems = document.querySelectorAll('.concretehouse__item.none');
            concretehouseItems.forEach(el => {
                el.classList.remove('none');
                concretehouseBtnMore.style.display = 'none';
            });
        });
    }
    // Показать еще


    // Запуск видео
    const videos = document.querySelectorAll('.lazyVideo video');
    
    // Создаем Intersection Observer
    let observer = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) { // Если элемент виден
                entry.target.src = entry.target.dataset.src; // Устанавливаем источник видео
                entry.target.load(); // Загружаем видеофайл
                entry.target.play(); // Начинаем воспроизведение
                entry.target.controls = true; // Включаем элементы управления
                
                // Отключаем наблюдение за элементом
                self.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '0px',
        threshold: 0.2 // Воспроизводим видео, когда оно хотя бы частично видно
    });

    if (videos) {
        // Наблюдение за каждым элементом
        videos.forEach(video => {
            observer.observe(video); // Начнем наблюдать за элементами
        });
    }
    // Запуск видео


    // Slider
    (function() {
        const sliderItems = document.querySelectorAll('.houseslider__slider-item');
        let currentIndex1 = 0;
    
        // Проверяем существование элементов
        if (!sliderItems || sliderItems.length === 0) return; // Выход, если нет слайдов
    
        const nextButton = document.querySelector('.houseslider__slider-btn-right');
        const prevButton = document.querySelector('.houseslider__slider-btn-left');
    
        // Устанавливаем обработчики только если кнопки существуют
        if (nextButton) {
            nextButton.addEventListener('click', nextSlide);
        }
    
        if (prevButton) {
            prevButton.addEventListener('click', prevSlide);
        }
    
        function nextSlide() {
            currentIndex1++;
            if (currentIndex1 >= sliderItems.length) {
                currentIndex1 = 0;
            }
            updateActiveSlide();
        }
    
        function prevSlide() {
            currentIndex1--;
            if (currentIndex1 < 0) {
                currentIndex1 = sliderItems.length - 1;
            }
            updateActiveSlide();
        }
    
        function updateActiveSlide() {
            sliderItems.forEach(item => item.classList.remove('active'));
            sliderItems[currentIndex1].classList.add('active');
        }
    
        // Начало автоматического переключения слайдов
        let houseSliderTime = null;
    
        startAutoSlide();
    
        function startAutoSlide() {
            houseSliderTime = setInterval(nextSlide, 5000);
        }
    
        function stopAutoSlide() {
            clearInterval(houseSliderTime);
        }
    
        // Определение области, на которую реагируют события mouseenter/mouseleave
        const sliderContainer = document.querySelector('.houseslider__slider-wrap');
    
        // Останавливаем авто-просмотр при наведении
        sliderContainer.addEventListener('mouseenter', () => {
            stopAutoSlide();
        });
    
        // Полностью отключаем авто-просмотр после ухода курсора
        sliderContainer.addEventListener('mouseleave', () => {
            stopAutoSlide(); // Останавливаем автослайдинг
            houseSliderTime = null; // Завершаем цикл навсегда
        });
    
        // Изначально активируем первый слайд
        updateActiveSlide();

        // Реализуем swipe-жесты
        let touchStartX = 0;
        let touchEndX = 0;

        // Свайпы и реакции на перемещения мыши
        sliderContainer.addEventListener('touchstart', handleTouchStart, false);
        sliderContainer.addEventListener('touchmove', handleTouchMove, false);
        sliderContainer.addEventListener('touchend', handleTouchEnd, false);

        // Имитация свайпов на десктопах с помощью мыши
        sliderContainer.addEventListener('mousedown', handleMouseDown, false);
        sliderContainer.addEventListener('mousemove', handleMouseMove, false);
        sliderContainer.addEventListener('mouseup', handleMouseUp, false);

        function handleTouchStart(e) {
            touchStartX = e.touches[0].clientX;
        }

        function handleTouchMove(e) {
            touchEndX = e.touches[0].clientX;
        }

        function handleTouchEnd() {
            detectSwipeDirection(touchStartX, touchEndX);
        }

        function handleMouseDown(e) {
            touchStartX = e.clientX;
        }

        function handleMouseMove(e) {
            touchEndX = e.clientX;
        }

        function handleMouseUp() {
            detectSwipeDirection(touchStartX, touchEndX);
        }

        function detectSwipeDirection(startX, endX) {
            const deltaX = Math.abs(endX - startX);
            if (deltaX > 50) { // Минимальное расстояние для распознавания свайпа
                if (endX < startX) {
                    nextSlide(); // Свайп влево — следующий слайд
                } else {
                    prevSlide(); // Свайп вправо — предыдущий слайд
                }
            }
        }
    })();
    // Slider
    




    // Характеристики список
    const housesliderSpecificationsBtn = document.querySelector('.houseslider__specifications-btn');
    if (housesliderSpecificationsBtn) {
        const spanTextElement = housesliderSpecificationsBtn.querySelector('span'); // Найдем span внутри кнопки
        const housesliderSpecificationsItems = document.querySelectorAll('.houseslider__specifications-item.none');

        let isOpen = false; // Переменная для хранения состояния

        housesliderSpecificationsBtn.addEventListener('click', () => {
            // Переключение состояний элементов
            housesliderSpecificationsItems.forEach((el) => {
                el.classList.toggle('show');
            });

            // Управление состоянием кнопки
            isOpen = !isOpen;
            spanTextElement.textContent = isOpen ? 'Скрыть список' : 'Весь список'; // Меняем текст в span
            housesliderSpecificationsBtn.classList.toggle('active');
        });
    }
    // Характеристики список
    // end page housekit
    


});
